import React, {useState} from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import { types as sdkTypes } from '../../util/sdkLoader';
const sharetribeSdk = require('sharetribe-flex-sdk');
import css from './EditListingProfessionalInfoForm.module.css';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';


const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function countryToFlag(isoCode) {
  return typeof String.fromCodePoint !== 'undefined'
    ? isoCode
        .toUpperCase()
        .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
    : isoCode;
}


// import { indexOf } from 'core-js/core/array';


const sdk = sharetribeSdk.createInstance({
    clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID
  });

  const { UUID } = sdkTypes;

const useStyles = makeStyles({
  option: {
    fontSize: "17px !important",
    '& > span': {
      marginRight: "10px !important",
      fontSize: "20px !important",
      border: "none",
    },
  },
});

export default function UniversitySearch(props) {
  const classes = useStyles();
  const options = props.trackLabel === "Track: medical" ? medicalSchools : ( props.trackLabel === "Track: dental" ? dentalSchools : (props.trackLabel === "Track: law" ? lawSchools : [...medicalSchools, ...dentalSchools, ...lawSchools]) );
  const signupOptions = props.track === "medical" ? medicalSchools : props.track === "dental" ? dentalSchools : props.track === "law" ? lawSchools : props.track === "physician" ? physicianSchools : props.track === "veterinary" ? vetSchools : props.track === "college" ? collegeSchools : [...medicalSchools, ...dentalSchools, ...lawSchools, ...physicianSchools, ...vetSchools, ...collegeSchools];
  const searchBarOptions = props.trackLabel === "Track: medical" ? medicalSchools : ( props.trackLabel === "Track: dental" ? dentalSchools : (props.trackLabel === "Track: law" ? lawSchools : [...medicalSchools, ...dentalSchools, ...lawSchools]) );
  const [schoolValue, setSchoolValue] = useState("")
  const schoolHandleChange = (event, values) => {
    setSchoolValue(values)

    if(props.contactUs ){
      console.log("nothing happens")
    
    }else if(values !== null && values.School){

      const oldCombinedSchoolSearch = props.listing.attributes.publicData.combinedSchoolSearch;

      if(oldCombinedSchoolSearch){
        const newCombinedSchoolSearch = [...oldCombinedSchoolSearch];
  
        const oldSchool = props.listing.attributes.publicData.schoolForSearch;
  
        if(oldSchool){
            if(newCombinedSchoolSearch.includes(oldSchool[0])){
              const index = newCombinedSchoolSearch.indexOf(oldSchool[0]);
              newCombinedSchoolSearch.splice(index, 1);
           }
        }
    
          newCombinedSchoolSearch.push(values.School)
        
        
  
  
      return sdk.ownListings.update({
        id: new UUID(props.listing.id.uuid),
        publicData: {
              school: values,
              schoolForSearch: [values.School],
              combinedSchoolSearch: [ ...newCombinedSchoolSearch ]
          },
        }).then(resp => {
          console.log(resp)
        }).catch(error => {
          console.log(error)
          console.log("error at updating master listing after brainstorm")
      })

      }else{
        // _______________________________________________________________________

        return sdk.ownListings.query({}).then(res => {
          const listingsArray = res.data.data;
         const masterCalProperty =  listingsArray.find(listing => {
            return listing.attributes.state === "draft"
          });
          return masterCalProperty
       }).then(res => {
              const sdkOldCombinedSchoolSearch = res.attributes.publicData.combinedSchoolSearch;
              
              const newCombinedSchoolSearch = sdkOldCombinedSchoolSearch ? [...sdkOldCombinedSchoolSearch] : [];
  
              const oldSchool = res.attributes.publicData.schoolForSearch;
        
              if(oldSchool){
                    if(newCombinedSchoolSearch.includes(oldSchool[0])){
                      const index = newCombinedSchoolSearch.indexOf(oldSchool[0]);
                      newCombinedSchoolSearch.splice(index, 1);
                    }
              }
                
                newCombinedSchoolSearch.push(values.School)
              
              
        
        
            return sdk.ownListings.update({
              id: new UUID(props.listing.id.uuid),
              publicData: {
                    school: values,
                    schoolForSearch: [values.School],
                    combinedSchoolSearch: [ ...newCombinedSchoolSearch ]
                },
              }).then(resp => {
                console.log(resp)
              }).catch(error => {
                console.log(error)
                console.log("error at updating master listing after brainstorm")
            })
      




        }).catch(error =>{
           console.log(error)});


      }

    
  
  
  
  
  }else{
      return console.log("no sdk call")
    }



  }


 const contactSchoolHandleChange = (event, values) => {
   if(values !== null){
    props.setContactSchool(values.School);
    console.log(values.School)}
 }

  

  return (

    props.searchBar === true ?
    (<Autocomplete
    className={css.searchBarAutocomplete}
    multiple
    limitTags={1}
      id="school"
      name="school"
      disableCloseOnSelect
      style={{ width: "100%" }}
      defaultValue={props.defaultSchoolValue}
      onChange={props.searchBarFunction}
      options={props.mobile === true ? [...medicalSchools, ...dentalSchools, ...lawSchools ] : searchBarOptions}
      classes={{
        option: classes.option,
      }}
      autoHighlight
      getOptionLabel={(option) => option.School}
      renderOption={(option, { selected }) => (
        <React.Fragment>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option.School}
        </React.Fragment>
      )}
      renderInput={(params) => {
          
        return (  
        <TextField
        id="school"
        name="school"
          {...params}
          label={"Search by school"}
          variant="outlined"
          inputProps={
            {
            ...params.inputProps,
           // autoComplete: 'new-password', // disable autocomplete and autofill
          }}
        />
      )
    }
    }
    /> ) : props.secondaryFilters === true ? (
      <Autocomplete
    multiple
    limitTags={1}
      id="schoolSecFilters"
      name="schoolSecFilters"
      disableCloseOnSelect
      style={{ width: "100%" }}
      defaultValue={props.defaultSchoolValue}
      onChange={props.secFiltersFunction}
      options={searchBarOptions}
      classes={{
        option: classes.option,
      }}
      autoHighlight
      getOptionLabel={(option) => option.School}
      renderOption={(option, { selected }) => (
        <React.Fragment>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option.School}
        </React.Fragment>
      )}
      renderInput={(params) => {
          
        return (  
        <TextField
        id="school"
        name="school"
          {...params}
          label={"Search by school"}
          variant="outlined"
          inputProps={
            {
            ...params.inputProps,
           // autoComplete: 'new-password', // disable autocomplete and autofill
          }}
        />
      )
    }
    }
    />
    ) : props.contactUs === true ? (
    <Autocomplete
    id="school"
    name="school"
    style={{ width: "100%" }}
    onChange={contactSchoolHandleChange}
    defaultValue={props.defaultSchoolValue}
    options={options}
    classes={{
      option: classes.option,
    }}
    autoHighlight
    getOptionLabel={(option) => option.School}
    renderOption={(option) => (
      <React.Fragment>
        {option.School} ({option.State})
      </React.Fragment>
    )}
    renderInput={(params) => {
        
      return (  
      <TextField
      id="school"
      name="school"
        {...params}
        label="Choose a school"
        variant="outlined"
        inputProps={
          {
          ...params.inputProps,
         // autoComplete: 'new-password', // disable autocomplete and autofill
        }}
      />
    )
  }
  }
  />
  ) : props.helperSignup ? (
          <Autocomplete
              id="school"
              name="school"
              style={{ width: "100%" }}
              defaultValue={props.defaultSchoolValue}
              onChange={schoolHandleChange}
              options={signupOptions}
              classes={{
                option: classes.option,
              }}
              autoHighlight
              getOptionLabel={(option) => option.School}
              renderOption={(option) => (
                <React.Fragment>
                  {option.School} ({option.State})
                </React.Fragment>
              )}
              renderInput={(params) => {
                  
                return (  
                <TextField
                id="school"
                name="school"
                  {...params}
                  label="Choose a school"
                  variant="outlined"
                  inputProps={
                    {
                    ...params.inputProps,
                  // autoComplete: 'new-password', // disable autocomplete and autofill
                  }}
                />
              )
            }
            }
            />
  ) : (
    <Autocomplete
        id="school"
        name="school"
        style={{ width: "100%" }}
        defaultValue={props.defaultSchoolValue}
        onChange={schoolHandleChange}
        options={options}
        classes={{
          option: classes.option,
        }}
        autoHighlight
        getOptionLabel={(option) => option.School}
        renderOption={(option) => (
          <React.Fragment>
            {option.School} ({option.State})
          </React.Fragment>
        )}
        renderInput={(params) => {
            
          return (  
          <TextField
          id="school"
          name="school"
            {...params}
            label="Choose a school"
            variant="outlined"
            inputProps={
              {
              ...params.inputProps,
            // autoComplete: 'new-password', // disable autocomplete and autofill
            }}
          />
        )
      }
      }
      />
)
  );
}
const medicalSchools = [
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "University of Alabama at Birmingham School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "University of South Alabama College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Alabama College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Edward Via College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "A.T. Still University School of Osteopathic Medicine in Arizona"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Mayo Clinic School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Midwestern University Arizona College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "University of Arizona College of Medicine - Phoenix"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "University of Arizona College of Medicine - Tucson"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "University of Arkansas for Medical Sciences/UAMS College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "Arkansas College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "New York Institute of Technology College of Osteopathic Medicine at Arkansas State University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California Northstate University College of Medicine"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California University of Science and Medicine"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Charles R. Drew University of Medicine and Science"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Kaiser Permanente School of Medicine"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Keck School of Medicine of University of Southern California"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Loma Linda University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Stanford University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of California - Davis School of Medicine"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of California - Irvine School of Medicine"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "David Geffen School of Medicine at UCLA"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of California - Riverside School of Medicine"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of California - San Diego School of Medicine"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "UCSF School of Medicine"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California Health Sciences University College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Touro University California College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Western University of Health Sciences College of Osteopathic Medicine of the Pacific"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "University of Colorado School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Rocky Vista University College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Frank H. Netter M.D. School of Medicine at Quinnipiac University"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "University of Connecticut School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Yale School of Medicine"
  },
  {
      "Country": "United States",
      "State": "District of Columbia",
      "School": "George Washington University School of Medicine& Health Sciences"
  },
  {
      "Country": "United States",
      "State": "District of Columbia",
      "School": "Georgetown University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "District of Columbia",
      "School": "Howard University College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Florida Atlantic University Charles E. Schmidt College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Florida International University Herbert Wertheim College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Florida State University College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "University of Central Florida College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "University of Florida College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "University of Miami Leonard M. Miller School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "University of South Florida College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Lake Erie College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Nova Southeastern University College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Nova Southeastern University Kiran C. Patel College of Allopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Emory University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Medical College of Georgia at Augusta University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Mercer University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Morehouse School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Philadelphia College of Osteopathic Medicine - Georgia Campus"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Philadelphia College of Osteopathic Medicine - South Georgia Campus"
  },
  {
      "Country": "United States",
      "State": "Hawaii",
      "School": "University of Hawaii at Manoa John A. Burns School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Idaho",
      "School": "Idaho College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "Carle Illinois College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "Loyola University Chicago Stritch School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "Northwestern University Feinberg School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "Chicago Medical School of Rosalind Franklin University of Medicine and Science"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "Rush Medical College"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "Southern Illinois University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "University of Chicago Pritzker School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "University of Illinois College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "Midwestern University Chicago College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Indiana University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Marian University College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "University of Iowa Roy J. and Lucille A. Carver College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Des Moines University College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "University of Kansas School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "University of Kentucky College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "University of Louisville School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "University of Pikeville Kentucky College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Louisiana State University School of Medicine in New Orleans"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Louisiana State University School of Medicine in Shreveport"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Tulane University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Edward Via College of Osteopathic Medicine-Louisiana Campus"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "University of New England College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Johns Hopkins University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Uniformed Services University of the Health Sciences F. Edward Hebert School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "University of Maryland School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "Boston University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "Harvard Medical School"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "Tufts University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "University of Massachusetts Medical School"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Central Michigan University College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Michigan State University College of Human Medicine"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "University of Michigan Medical School"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Oakland University William Beaumont School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Wayne State University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Western Michigan University Homer Stryker M.D. School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Michigan State University College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Mayo Clinic Alix School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "University of Minnesota Medical School"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "University of Minnesota Medical School"
  },
  {
      "Country": "United States",
      "State": "Mississippi",
      "School": "University of Mississippi School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Mississippi",
      "School": "William Carey University College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Saint Louis University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "University of Missouri-Columbia School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "University of Missouri–Kansas City School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Washington University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "A.T. Still University Kirksville College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Kansas City University of Medicine and Biosciences College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "Creighton University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "University of Nebraska College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Nevada",
      "School": "University of Nevada - Las Vegas School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Nevada",
      "School": "University of Nevada - Reno School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Nevada",
      "School": "Touro University Nevada College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "Dartmouth College Geisel School of Medicine"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Hackensack Meridian School of Medicine at Seton Hall"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Cooper Medical School of Rowan University"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Rutgers New Jersey Medical School"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Rutgers Robert Wood Johnson Medical School"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Rowan University School of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "New Mexico",
      "School": "University of New Mexico School of Medicine"
  },
  {
      "Country": "United States",
      "State": "New Mexico",
      "School": "Burrell College of Osteopathic Medicine at New Mexico State University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Albany Medical College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Albert Einstein College of Medicine"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Columbia University Roy and Diana Vagelos College of Physicians and Surgeons"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "CUNY School of Medicine"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Donald and Barbara Zucker School of Medicine at Hofstra/Northwell"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Icahn School of Medicine at Mount Sinai"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "New York Medical College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "New York University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "New York University Long Island School of Medicine"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Renaissance School of Medicine at Stony Brook University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "State University of New York Upstate Medical University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "State University of New York Downstate Medical Center College of Medicine"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Jacobs School of Medicine and Biomedical Sciences - University at Buffalo"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "University of Rochester School of Medicine and Dentistry"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Weill Cornell Medical College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "New York Institute of Technology College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Touro College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "The Brody School of Medicine at East Carolina University"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "Duke University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "University of North Carolina School of Medicine"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "Wake Forest School of Medicine"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "Campbell University School of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "North Dakota",
      "School": "University of North Dakota School of Medicine and Health Sciences"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Wright State University Boonshoft School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Case Western Reserve University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Cleveland Clinic Lerner College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Northeast Ohio Medical University College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "The Ohio State University College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "University of Cincinnati College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "University of Toledo College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Ohio University Heritage College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "University of Oklahoma College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "University of Oklahoma School of Community Medicine"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Oklahoma State University Center for Health Sciences College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Oregon Health & Science University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "College of Osteopathic Medicine of the Pacific - Northwest"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Geisinger Commonwealth School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Drexel University College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Pennsylvania State University College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Perelman School of Medicine at the University of Pennsylvania"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Sidney Kimmel Medical College At Thomas Jefferson University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Lewis Katz School of Medicine at Temple University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "University of Pittsburgh School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Lake Erie College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Philadelphia College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Puerto Rico",
      "School": "Universidad Central del Caribe School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Puerto Rico",
      "School": "Ponce School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Puerto Rico",
      "School": "San Juan Bautista School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Puerto Rico",
      "School": "University of Puerto Rico School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Rhode Island",
      "School": "Alpert Medical School at Brown University"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Medical University of South Carolina College of Medicine"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "University of South Carolina School of Medicine"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "University of South Carolina School of Medicine Greenville"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Edward Via College of Osteopathic Medicine - Carolinas Campus"
  },
  {
      "Country": "United States",
      "State": "South Dakota",
      "School": "Sanford School of Medicine of the University of South Dakota"
  },
  {
      "Country": "United States",
      "State": "Tennessee",
      "School": "East Tennessee State University James H. Quillen College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Tennessee",
      "School": "Meharry Medical College School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Tennessee",
      "School": "University of Tennessee College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Tennessee",
      "School": "Vanderbilt University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Tennessee",
      "School": "Lincoln Memorial University DeBusk College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Baylor College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas A&M Health Science Center College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas Tech University Health Sciences Center Paul L. Foster School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "TCU and UNTHSC School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas Tech University Health Sciences Center School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas Medical Branch School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas Medical School at Houston"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas School of Medicine at San Antonio"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas Rio Grande Valley School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas Southwestern Medical School at Dallas"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Dell Medical School at The University of Texas at Austin"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of the Incarnate Word School of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of North Texas Health Science Center Texas College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Utah",
      "School": "University of Utah School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Utah",
      "School": "Rocky Vista University College of Osteopathic Medicine - Southern Utah Campus"
  },
  {
      "Country": "United States",
      "State": "Vermont",
      "School": "University of Vermont College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "Eastern Virginia Medical School"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "University of Virginia School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "VCU School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "Virginia Tech Carilion School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "Edward Via College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "Liberty University College of Osteopathic Medicine (LUCOM)"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "University of Washington School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Washington State University Elson S. Floyd College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Pacific Northwest University of Health Sciences College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "West Virginia",
      "School": "Joan C. Edwards School of Medicine at Marshall University"
  },
  {
      "Country": "United States",
      "State": "West Virginia",
      "School": "West Virginia University School of Medicine"
  },
  {
      "Country": "United States",
      "State": "West Virginia",
      "School": "West Virginia School of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Medical College of Wisconsin"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "University of Wisconsin School of Medicine and Public Health"
  },
  {
      "Country": "Canada",
      "State": "Alberta",
      "School": "University of Alberta"
  },
  {
      "Country": "Canada",
      "State": "Alberta",
      "School": "University of Calgary"
  },
  {
      "Country": "Canada",
      "State": "British Columbia",
      "School": "University of British Columbia"
  },
  {
      "Country": "Canada",
      "State": "Manitoba",
      "School": "University of Manitoba"
  },
  {
      "Country": "Canada",
      "State": "Newfoundland and Labrador",
      "School": "Memorial University of Newfoundland"
  },
  {
      "Country": "Canada",
      "State": "Nova Scotia",
      "School": "Dalhousie University"
  },
  {
      "Country": "Canada",
      "State": "Quebec",
      "School": "McGill University"
  },
  {
      "Country": "Canada",
      "State": "Quebec",
      "School": "Université Laval"
  },
  {
      "Country": "Canada",
      "State": "Quebec",
      "School": "Université de Montréal"
  },
  {
      "Country": "Canada",
      "State": "Quebec",
      "School": "Université de Sherbrooke"
  },
  {
      "Country": "Canada",
      "State": "Quebec",
      "School": "University of Ottawa"
  },
  {
      "Country": "Canada",
      "State": "Ontario",
      "School": "Northern Ontario School of Medicine"
  },
  {
      "Country": "Canada",
      "State": "Ontario",
      "School": "McMaster University"
  },
  {
      "Country": "Canada",
      "State": "Ontario",
      "School": "Western University"
  },
  {
      "Country": "Canada",
      "State": "Ontario",
      "School": "University of Toronto"
  },
  {
      "Country": "Canada",
      "State": "Ontario",
      "School": "Queen's University"
  },
  {
      "Country": "Canada",
      "State": "Saskatchewan",
      "School": "University of Saskatchewan"
  }
]


const lawSchools = [
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Birmingham School of Law"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Cumberland School of Law - Samford University"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Thomas Goode Jones School of Law - Faulkner University"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "University of Alabama School of Law"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "University of Arizona James E. Rogers College of Law"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Arizona State University - Sandra Day O'Connor College of Law"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "University of Arkansas"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "William H. Bowen School of Law - University of Arkansas at Little Rock"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Cal Northern School of Law"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California Western School of Law"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Caruso School of Law - Pepperdine University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Dale E. Fowler School of Law - Chapman University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Drivon School of Law - Humphreys University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Empire College School of Law"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Glendale University College of Law"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Golden Gate University School of Law"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "John F. Kennedy University School of Law"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Lincoln Law School of Sacramento"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Lincoln Law School of San Jose"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Loyola Law School - Loyola Marymount University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "McGeorge School of Law - University of the Pacific"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Monterey College of Law"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Pacific Coast University School of Law"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "San Francisco Law School - Alliant International University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "San Joaquin College of Law"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Santa Barbara College of Law"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Santa Clara University School of Law"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Southern California Institute of Law - Santa Barbara"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Southern California Institute of Law - Ventura"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Southwestern Law School"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Stanford Law School "
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Thomas Jefferson School of Law"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Trinity Law School - Trinity International University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "UC Berkeley School of Law - University of California at Berkeley"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "UC Davis School of Law - University of California at Davis"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "UC Hastings College of the Law - University of California"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "UC Irvine School of Law - University of California at Irvine"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "UCLA School of Law - University of California at Los Angeles"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of La Verne"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of San Diego School of Law"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of San Francisco School of Law"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of West Los Angeles School of Law"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "USC Gould School of Law - University of Southern California"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Ventura College of Law"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Western State University College of Law - Westcliff University"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Sturm College of Law - University of Denver"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "University of Colorado School of Law"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Quinnipiac University School of Law"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "University of Connecticut School of Law"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Yale Law School "
  },
  {
      "Country": "United States",
      "State": "Delaware",
      "School": "Delaware Law School - Widener University"
  },
  {
      "Country": "United States",
      "State": "District of Columbia",
      "School": "Columbus School of Law - The Catholic University of America"
  },
  {
      "Country": "United States",
      "State": "District of Columbia",
      "School": "David A. Clarke School of Law - University of District of Columbia"
  },
  {
      "Country": "United States",
      "State": "District of Columbia",
      "School": "The George Washington University Law School"
  },
  {
      "Country": "United States",
      "State": "District of Columbia",
      "School": "Georgetown University Law Center"
  },
  {
      "Country": "United States",
      "State": "District of Columbia",
      "School": "Howard University School of Law"
  },
  {
      "Country": "United States",
      "State": "District of Columbia",
      "School": "Washington College of Law - American University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Ave Maria School of Law"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Dwayne O. Andreas School of Law - Barry University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Florida A&M University College of Law - Florida Agricultural and Mechanical University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Florida Coastal School of Law"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Florida International University College of Law"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Florida State University College of Law"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "University of Florida Levin College of Law"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Shepard Broad Law Center - Nova Southeastern University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "St. Thomas University School of Law"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Stetson University College of Law"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "University of Miami School of Law "
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Atlanta’s John Marshall Law School"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Emory University School of Law"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Georgia State University College of Law"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Mercer University School of Law"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Savannah Law School"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "University of Georgia School of Law"
  },
  {
      "Country": "United States",
      "State": "Hawaii",
      "School": "William S. Richardson School of Law - University of Hawai'i at Manoa"
  },
  {
      "Country": "United States",
      "State": "Idaho",
      "School": "Concordia University School of Law - Concordia University - St. Paul"
  },
  {
      "Country": "United States",
      "State": "Idaho",
      "School": "University of Idaho College of Law"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "Chicago-Kent College of Law - Illinois Institute of Technology"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "DePaul College of Law - DePaul University"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "Loyola University Chicago School of Law"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "Northern Illinois University College of Law"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "Northwestern University Pritzker School of Law"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "Southern Illinois University School of Law"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "UIC John Marshall Law School - University of Illinois at Chicago"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "University of Chicago Law School"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "University of Illinois College of Law"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Indiana University Maurer School of Law"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Notre Dame Law School"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Robert H. McKinney School of Law - Indiana University"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Drake Law School - Drake University"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "University of Iowa College of Law"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "University of Kansas School of Law"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Washburn University School of Law"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "J. David Rosenberg College of Law - University of Kentucky"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Louis D. Brandeis School of Law - University of Louisville"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "NKU Chase College of Law - Northern Kentucky University"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Loyola University New Orleans College of Law"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Paul M. Hebert Law Center - Louisiana State University"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Southern University Law Center"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Tulane University School of Law"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "University of Maine School of Law"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "University of Maryland School of Law"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "University of Baltimore School of Law"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "Boston College Law School"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "Boston University School of Law"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "Harvard Law School "
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "Massachusetts School of Law"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "New England Law | Boston"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "Northeastern University School of Law "
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "Suffolk University Law School"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "University of Massachusetts School of Law - University of Massachusetts Dartmouth"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "Western New England University School of Law "
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Michigan State University College of Law"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Thomas M. Cooley Law School - Western Michigan University"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "University of Detroit Mercy School of Law"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "University of Michigan Law School"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Wayne State University Law School"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Mitchell Hamline School of Law - Hamline University"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "University of Minnesota Law School"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "University of St. Thomas School of Law "
  },
  {
      "Country": "United States",
      "State": "Mississippi",
      "School": "Mississippi College School of Law"
  },
  {
      "Country": "United States",
      "State": "Mississippi",
      "School": "University of Mississippi School of Law"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Saint Louis University School of Law"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "University of Missouri School of Law"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "University of Missouri–Kansas City School of Law"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Washington University School of Law"
  },
  {
      "Country": "United States",
      "State": "Montana",
      "School": "Alexander Blewett III School of Law - University of Montana"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "Creighton University School of Law"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "University of Nebraska College of Law - University of Nebraska-Lincoln"
  },
  {
      "Country": "United States",
      "State": "Nevada",
      "School": "William S. Boyd School of Law - University of Nevada - Las Vegas"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "Franklin Pierce School of Law - University of New Hampshire"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Rutgers University School of Law - Camden - Rutgers University | Camden"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Rutgers University School of Law - Newark - Rutgers University | Newark"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Seton Hall University School of Law"
  },
  {
      "Country": "United States",
      "State": "New Mexico",
      "School": "University of New Mexico School of Law"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Albany Law School "
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Benjamin N. Cardozo School of Law - Yeshiva University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Brooklyn Law School"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Columbia Law School"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Cornell Law School"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "CUNY School of Law - City University of New York"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Elisabeth Haub School of Law - Pace University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Fordham University School of Law"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Jacob D. Fuchsberg Law Center - Touro College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Maurice A. Deane School of Law - Hofstra University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "New York University School of Law"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "St. John's University School of Law"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Syracuse University College of Law"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "University at Buffalo School of Law"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "Duke University School of Law"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "Elon University School of Law"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "Norman Adrian Wiggins School of Law - Campbell University"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "North Carolina Central University School of Law"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "University of North Carolina School of Law"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "Wake Forest University School of Law"
  },
  {
      "Country": "United States",
      "State": "North Dakota",
      "School": "University of North Dakota School of Law"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Capital University Law School"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Case Western Reserve University School of Law"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Claude W. Pettit School of Law - Ohio Northern University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Cleveland-Marshall College of Law - Cleveland State University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Michael E. Moritz College of Law at Ohio State University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "University of Akron School of Law"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "University of Cincinnati College of Law"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "University of Dayton School of Law"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "University of Toledo College of Law"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Oklahoma City University School of Law"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "University of Oklahoma College of Law"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "University of Tulsa College of Law"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Northwestern School of Law of Lewis and Clark College"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "University of Oregon School of Law"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Willamette University College of Law"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Temple University James E. Beasley School of Law"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Villanova University's Charles Widger School of Law"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Penn State Dickinson Law"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Duquesne University School of Law"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "University of Pennsylvania Law School"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Drexel University Thomas R. Kline School of Law"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "University of Pittsburgh School of Law"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Widener University Commonwealth Law School"
  },
  {
      "Country": "United States",
      "State": "Puerto Rico",
      "School": "Inter American University of Puerto Rico - Faculty of Law"
  },
  {
      "Country": "United States",
      "State": "Puerto Rico",
      "School": "Pontifical Catholic University of Puerto Rico School of Law"
  },
  {
      "Country": "United States",
      "State": "Puerto Rico",
      "School": "University of Puerto Rico School of Law"
  },
  {
      "Country": "United States",
      "State": "Rhode Island",
      "School": "Roger Williams University School of Law"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Charleston School of Law"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "University of South Carolina School of Law"
  },
  {
      "Country": "United States",
      "State": "South Dakota",
      "School": "University of South Dakota School of Law"
  },
  {
      "Country": "United States",
      "State": "Tennessee",
      "School": "Belmont University College of Law "
  },
  {
      "Country": "United States",
      "State": "Tennessee",
      "School": "University of Memphis Cecil C. Humphreys School of Law"
  },
  {
      "Country": "United States",
      "State": "Tennessee",
      "School": "Duncan School of Law at Lincoln Memorial University"
  },
  {
      "Country": "United States",
      "State": "Tennessee",
      "School": "University of Tennessee College of Law"
  },
  {
      "Country": "United States",
      "State": "Tennessee",
      "School": "Vanderbilt University Law School"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Baylor Law School "
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "SMU Dedman School of Law at Southern Methodist University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "South Texas College of Law Houston"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "St. Mary's University School of Law"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas A&M University School of Law"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas Tech University School of Law"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Thurgood Marshall School of Law - Texas Southern University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Houston Law Center"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas School of Law"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "UNT Dallas College of Law - University of North Texas at Dallas"
  },
  {
      "Country": "United States",
      "State": "Utah",
      "School": "J. Reuben Clark Law School at Brigham Young University"
  },
  {
      "Country": "United States",
      "State": "Utah",
      "School": " S.J. Quinney College of Law at University of Utah"
  },
  {
      "Country": "United States",
      "State": "Vermont",
      "School": "Vermont Law School"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "George Mason University School of Law"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "Appalachian School of Law"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "Liberty University School of Law"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "Regent University School of Law"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "University of Richmond School of Law"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "University of Virginia School of Law"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "Washington and Lee University School of Law"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "William & Mary Law School "
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Gonzaga University School of Law"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Seattle University School of Law"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "University of Washington School of Law"
  },
  {
      "Country": "United States",
      "State": "West Virginia",
      "School": "West Virginia University College of Law"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Marquette University Law School"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "University of Wisconsin Law School"
  },
  {
      "Country": "United States",
      "State": "Wyoming",
      "School": "University of Wyoming College of Law"
  },
  {
      "Country": "Canada",
      "State": "Nova Scotia",
      "School": "Schulich School of Law at Dalhousie University"
  },
  {
      "Country": "Canada",
      "State": "Ontario",
      "School": "Bora Laskin Faculty of Law at Lakehead University"
  },
  {
      "Country": "Canada",
      "State": "Ontario",
      "School": "Queen's University Faculty of Law"
  },
  {
      "Country": "Canada",
      "State": "Ontario",
      "School": "Lincoln Alexander School of Law at Ryerson University"
  },
  {
      "Country": "Canada",
      "State": "Ontario",
      "School": "University of Ottawa Faculty of Law"
  },
  {
      "Country": "Canada",
      "State": "Ontario",
      "School": "University of Toronto Faculty of Law"
  },
  {
      "Country": "Canada",
      "State": "Ontario",
      "School": "University of Western Ontario Faculty of Law"
  },
  {
      "Country": "Canada",
      "State": "Ontario",
      "School": "University of Windsor Faculty of Law"
  },
  {
      "Country": "Canada",
      "State": "Ontario",
      "School": "Osgoode Hall Law School at York University"
  },
  {
      "Country": "Canada",
      "State": "Quebec",
      "School": "Faculty of Law at McGill University"
  },
  {
      "Country": "Canada",
      "State": "Quebec",
      "School": "Faculty of Law at Université de Montréal"
  },
  {
      "Country": "Canada",
      "State": "British Columbia",
      "School": "Thompson Rivers University Faculty of Law"
  },
  {
      "Country": "Canada",
      "State": "British Columbia",
      "School": "Peter A. Allard School of Law at the University of British Columbia"
  },
  {
      "Country": "Canada",
      "State": "British Columbia",
      "School": "University of Victoria Faculty of Law"
  },
  {
      "Country": "Canada",
      "State": "Alberta",
      "School": "University of Alberta Faculty of Law"
  },
  {
      "Country": "Canada",
      "State": "Alberta",
      "School": "University of Calgary Faculty of Law"
  },
  {
      "Country": "Canada",
      "State": "Manitoba",
      "School": "Robson Hall Faculty of Law at University of Manitoba"
  },
  {
      "Country": "Canada",
      "State": "New Brunswick",
      "School": "University of New Brunswick Faculty of Law"
  },
  {
      "Country": "Canada",
      "State": "New Brunswick",
      "School": "Université de Moncton Faculty of Law"
  },
  {
      "Country": "Canada",
      "State": "Saskatchewan",
      "School": "College of Law at the University of Saskatchewan"
  }
]

const dentalSchools = [
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "University of Alabama School of Dentistry - Birmingham"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Arizona School of Dentistry & Oral Health"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Midwestern University College of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California Northstate University College of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Herman Ostrow School of Dentistry of USC"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Loma Linda University School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "UCLA School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "UCSF School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of the Pacific Arthur A. Dugoni School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Western University of Health Sciences College of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "University of Colorado School of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "University of Connecticut School of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "District of Columbia",
      "School": "Howard University College of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "LECOM School of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Nova Southeastern University College of Dental Medicine,"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "University of Florida College of Dentistry "
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "The Dental College of Georgia at Augusta University"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "University of Illinois at Chicago College of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "Midwestern University College of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "Southern Illinois University School of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Indiana University School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "The University of Iowa College of Dentistry and Dental Clinics"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "University of Kentucky College of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "University of Louisville School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Louisiana State University Health Science Center School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "University of New England College of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "University of Maryland School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "Boston University Henry M. Goldman School of Dental Medicine,"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "Harvard University School of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "Tufts University School of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "University of Detroit Mercy School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "University of Michigan School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "University of Minnesota School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Mississippi",
      "School": "University of Mississippi Medical Center School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Missouri School of Dentistry & Oral Health at ATSU"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "University of Missouri-Kansas City School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "Creighton University School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "University of Nebraska Medical Center College of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Nevada",
      "School": "University of Nevada - Las Vegas School of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Rutgers School of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Columbia University College of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "New York University College of Dentistry"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Stony Brook University School of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Touro College of Dental Medicine at New York Medical College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "University at Buffalo School of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "East Carolina University School of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "University of North Carolina Chapel Hill School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Case Western Reserve University School of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Ohio State University College of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "University of Oklahoma College of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Oregon Health Sciences University School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "University of Pennsylvania School of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "University of Pittsburgh School of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Temple University Kornberg School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Puerto Rico",
      "School": "University of Puerto Rico - School of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Medical University of South Carolina College of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "Tennessee",
      "School": "Meharry Medical College School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Tennessee",
      "School": "University of Tennessee Health Science Center College of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas A&M University College of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas Tech University Health Sciences Center El Paso-Hunt School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas Health Science Center at Houston School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas Health Science Center at San Antonio School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Utah",
      "School": "Roseman University of Health Sciences College of Dental Medicine"
  },
  {
      "Country": "United States",
      "State": "Utah",
      "School": "University of Utah School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "Virginia Commonwealth University School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "University of Washington School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "West Virginia",
      "School": "West Virginia University School of Dentistry"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Marquette University School of Dentistry"
  },
  {
      "Country": "Canada",
      "State": "Alberta",
      "School": "University of Alberta School of Dentistry"
  },
  {
      "Country": "Canada",
      "State": "British Columbia",
      "School": "University of British Columbia Faculty of Dentistry"
  },
  {
      "Country": "Canada",
      "State": "Manitoba",
      "School": "University of Manitoba School of Dentistry"
  },
  {
      "Country": "Canada",
      "State": "Nova Scotia",
      "School": "Dalhousie University Faculty of Dentistry"
  },
  {
      "Country": "Canada",
      "State": "Ontario",
      "School": "University of Toronto Faculty of Dentistry"
  },
  {
      "Country": "Canada",
      "State": "Ontario",
      "School": "Western University of Schulich School of Medicine and Dentistry"
  },
  {
      "Country": "Canada",
      "State": "Québec",
      "School": "Université Laval Faculté de Médecine Dentaire"
  },
  {
      "Country": "Canada",
      "State": "Québec",
      "School": "McGill University Faculty of Dentistry"
  },
  {
      "Country": "Canada",
      "State": "Québec",
      "School": "Université de Montréal Faculté de Médecine Dentaire"
  },
  {
      "Country": "Canada",
      "State": "Saskatchewan",
      "School": "University of Saskatchewan College of Dentistry"
  }
]


const vetSchools = [
  {
      "Country": "United States ",
      "State": "Alabama",
      "School": "Auburn University College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Alabama",
      "School": "Tuskegee University College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Arizona",
      "School": "Midwestern University College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Arizona",
      "School": "University of Arizona College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "California",
      "School": "UC Davis School of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "California",
      "School": "Western University College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Colorado",
      "School": "Colorado State University College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Florida",
      "School": "University of Florida College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Georgia",
      "School": "University of Georgia College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Illinois",
      "School": "University of Illinois College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Indiana",
      "School": "Purdue University College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Iowa",
      "School": "Iowa State University's College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Kansas",
      "School": "Kansas State University College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Louisiana",
      "School": "LSU School of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Massachusetts",
      "School": "Cummings School of Veterinary Medicine at Tufts University"
  },
  {
      "Country": "United States ",
      "State": "Michigan",
      "School": "Michigan State University College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Minnesota",
      "School": "University of Minnesota College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Mississippi",
      "School": "Mississippi State University College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Missouri",
      "School": "College of Veterinary Medicine at the University of Missouri"
  },
  {
      "Country": "United States ",
      "State": "New York",
      "School": "Cornell University College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "New York",
      "School": "Long Island University College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "North Carolina",
      "School": "North Carolina State University College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Ohio",
      "School": "Ohio State University College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Oklahoma",
      "School": "Oklahoma State University College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Oregon",
      "School": "Carlson College of Veterinary Medicine at Oregon State University"
  },
  {
      "Country": "United States ",
      "State": "Pennsylvania",
      "School": "University of Pennsylvania School of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Tennessee",
      "School": "University of Tennessee College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Tennessee",
      "School": "Lincoln Memorial University College of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Texas",
      "School": "Texas A&M College of Veterinary Medicine & Biomedical Sciences"
  },
  {
      "Country": "United States ",
      "State": "Texas",
      "School": "Texas Tech University School of Veterinary Medicine"
  },
  {
      "Country": "United States ",
      "State": "Virginia",
      "School": "Virginia Maryland College of Veterinary Medicine "
  },
  {
      "Country": "United States ",
      "State": "Washington",
      "School": "Washington State University Veterinary School"
  },
  {
      "Country": "United States ",
      "State": "Wisconsin",
      "School": "University of Wisconsin School of Veterinary Medicine "
  },
  {
      "Country": "Canada",
      "State": "Quebec",
      "School": "Faculty of Veterinary Medicine at Université de Montréal"
  },
  {
      "Country": "Canada",
      "State": "Alberta",
      "School": "Faculty of Veterinary Medicine at University of Calgary \n"
  },
  {
      "Country": "Canada",
      "State": "Ontario",
      "School": "Ontario Veterinary College at University of Guelph"
  },
  {
      "Country": "Canada",
      "State": "Prince Edward Island",
      "School": "Atlantic Veterinary College at University of Prince Edward Island"
  },
  {
      "Country": "Canada",
      "State": "Saskatchewan",
      "School": "Western College of Veterinary Medicine at Saskatchewan University"
  }
]

const physicianSchools = [
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "University of Alabama - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "University of Alabama at Birmingham - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Arizona School of Health Sciences - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Midwestern University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Northern Arizona University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "Harding University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "University of Arkansas - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Loma Linda University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Marshall B. Ketchum University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Moreno Valley College - Physician Associate Program "
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Samuel Merritt University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Stanford University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Touro University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "UC Davis - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of Southern California (USC) - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Western University of Health Sciences - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Red Rocks Community College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "University of Colorado - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "University of Bridgeport - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Quinnipiac University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Yale University School of Medicine - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "District of Columbia",
      "School": "George Washington University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "District of Columbia",
      "School": "Howard University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Adventist University of Health Sciences - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Barry University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Florida University Herbert Werheim College of Medicine - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Keiser University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Miama Dade College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Nova Southeastern University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "South University - Tampa - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "University of Florida - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Emory University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Georgia Regents University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Mercer University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "South University - Savannah - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Idaho",
      "School": "Idaho State University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "Midwestern University - Downers Grove - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "Northwestern University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "Rosalind Franklin University of Medicine - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "Rush University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Illinois",
      "School": "Southern Illinois University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Butler University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Indiana State University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Indiana University School of Health and Rehabilitation Sciences - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "University of Saint Francis - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "St. Ambrose University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Des Moines University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "University of Iowa - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Wichita State University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "University of the Cumberlands - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Sullivan University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "University of Kentucky - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Our Lady of the Lake - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Louisiana State University - New Orleans - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Louisiana State University - Shreveport - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "University of New England - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Anne Arundel Community College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Towson University CCBC - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "University of Maryland Eastern Shore - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "Bay Path University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "Boston University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "MGH Institute of Health Professions - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "MCPHS University - Boston - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "Northeastern University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "Springfield College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Massachusetts",
      "School": "Tufts University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Central Michigan University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Eastern Michigan University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Grand Valley State University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "University of Detroit-Mercy - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Wayne State University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Western Michigan University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "St. Catherine University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Augsburg College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Bethel University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Mississippi",
      "School": "Mississippi College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Missouri State University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Saint Louis University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "University of Missouri-Kansas City - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Montana",
      "School": "Rocky Mountain College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "Union College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "University of Nebraska - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Nevada",
      "School": "Touro University Nevada - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "Franklin Pierce University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "MCPHS University - Manchester - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Monmouth University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Rutgers University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Seton Hall University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New Mexico",
      "School": "University of New Mexico - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New Mexico",
      "School": "University ov St. Francis - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Albany Medical College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "CCNY Sophie Davis School of Biomedical Education - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Clarkson University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Cornell University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "CUNY York College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Daemen College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "D'Youville College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Hofstra University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "LeMoyne College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Long Island University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Marist College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Mercy College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "New York Institute of Technology - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Pace University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Rochester Institute of Technology - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "St. John's University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Stone Brook University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "SUNY Downstate Medical Center - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "SUNY Upstate Medical Center - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Touro College - Bay Shore - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Touro College - Manhattan - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Wagner College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "Campbell University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "Duke University Medical Center - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "East Carolina University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "Elon University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "Gardner Webb University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "High Point University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "Lenoir-Rhyne University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "Methodist University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "University of North Carolina - Chapel Hill - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "Wake Forest University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "North Carolina",
      "School": "Wingate University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "North Dakota",
      "School": "North Dakota University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Baldwin Wallace University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Cuyahoga Community College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Kettering College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Lake Erie College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Marietta College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Ohio Dominican University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Ohio University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "University of Dayton - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "University of Toledo - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "University of Mount Union - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "University of Findlay - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Oklahoma City University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Kings College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Salus University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "University of Oklahoma - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Oregon Health and Science University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Pacific University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Arcadia University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Chatham University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "DeSales University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Drexel University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Duquesne University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Lock Haven University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Marywood University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Misericordoria University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Mercyhurst University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Penn State University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Pennsylvania College of Technology - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Philadelphia College of Osteopathic Medicine - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Philadelphia University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "St. Francis University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Seton Hill University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "Thomas Jefferson University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "University of Pittsburgh - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania",
      "School": "University of the Sciences of Philadelphia - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Rhode Island",
      "School": "Bryant University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Rhode Island",
      "School": "Johnson and Wales University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Medical University of South Carolina - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "South Dakota",
      "School": "University of South Dakota - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Tennessee",
      "School": "Bethel University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Tennessee",
      "School": "Christian Brothers University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Tennessee",
      "School": "Lincoln Memorial University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Tennessee",
      "School": "South College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Tennessee",
      "School": "Trevecca Nazarene University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Tennessee",
      "School": "University of Tennessee Health Science Center - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Baylor College of Medicine - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas Tech University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "US Army Interservice - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "UT Southern Medical Center - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of North Texas Health Science Center - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas Medical Branch - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas - Pan American - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Utah",
      "School": "Rocky Mountain University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Utah",
      "School": "University of Utah School of Medicine - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "Eastern Virginia Medical School - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "James Madison University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "Jefferson College of Health Sciences - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "Lynchburg College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "Mary Baldwin College - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Virginia",
      "School": "Shenandoah University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Heritage University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "University of Washington School of Medicine - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "West Virginia",
      "School": "Alderson Broaddus University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "West Virginia",
      "School": "University of Clarkson - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "West Virginia",
      "School": "West Liberty University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Carroll University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Concordia University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Marquette University - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "University of Wisconsin - La Crosse - Physician Associate Program"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "University of Wisconsin - Madison - Physician Associate Program"
  },
  {
      "Country": "Canada",
      "State": "Ontario",
      "School": "McMaster University - Physician Associate Program"
  },
  {
      "Country": "Canada",
      "State": "Ontario",
      "School": "PA Consortium - Physician Associate Program"
  },
  {
      "Country": "Canada",
      "State": "Manitoba",
      "School": "University of Manitoba - Physician Associate Program"
  }
]

const collegeSchools = [
  {
      "Country": "United States",
      "State": "Alaska",
      "School": "University of Alaska"
  },
  {
      "Country": "United States",
      "State": "Alaska",
      "School": "Alaska Christian College"
  },
  {
      "Country": "United States",
      "State": "Alaska",
      "School": "National Park Community College"
  },
  {
      "Country": "United States",
      "State": "Alaska",
      "School": "University of Alaska Fairbanks"
  },
  {
      "Country": "United States",
      "State": "Alaska",
      "School": "University of Arkansas – Fort Smith"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Alabama A&M University"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Athens State University"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Auburn University"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Auburn University at Montgomery"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Birmingham-Southern College"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Calhoun Community College"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Enterprise State Community College"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Faulkner State Community College"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Gadsden State  Community College"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Huntingdon College"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Jacksonville State University"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Lurleen B. Wallace Community College"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "University of Montevallo"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Northeast Alabama Community College"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Northwest-Shoals Community College"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Oakwood University"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Samford University"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Southeastern Bible College"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "University of South Alabama"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Trenholm State Technical College"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Troy University"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Tuskegee University"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "University of Alabama"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "University of Alabama at Birmingham"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "University of Alabama in Huntsville"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "University of North Alabama"
  },
  {
      "Country": "United States",
      "State": "Alabama",
      "School": "Snead State Community College"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "Arkansas Northeastern College"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "Arkansas State University"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "Arkansas Tech University"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "Central Baptist College"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "Harding University"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "Hendrix College"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "Henderson State University"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "John Brown University"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "Lyon College"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "Mid-South Community College"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "North Arkansas College"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "Northwest Arkansas Community College"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "Northwest Technical Institute"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "Ouachita Baptist University"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "University of the Ozarks"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "Phillips Community College U of A"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "Pulaski Technical College"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "Southern Arkansas University Magnolia"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "Southeast Arkansas College"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "University of Arkansas Community College Batesville"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "University of Arkansas at Little Rock"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "University of Arkansas for Medical Sciences"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "University of Arkansas at Pine Bluff"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "University of Arkansas"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "University of Central Arkansas"
  },
  {
      "Country": "United States",
      "State": "Arkansas",
      "School": "Williams Baptist College"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "University of Arizona"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Arizona State University"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Arizona Western College"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Bryan University"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Central Arizona College"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Glendale Community College"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Grand Canyon University"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Maricopa Community Colleges"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Mesa Community College"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Northern Arizona University"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Northland Pioneer  College"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "University of Phoenix"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Phoenix College"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Pima Community College"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Prescott College"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Rio Salado College"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "South Mountain Community College"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "University of Advancing Technology"
  },
  {
      "Country": "United States",
      "State": "Arizona",
      "School": "Yavapai College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Academy of Arts University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Adance Computing Institute"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Acupuncture & Integrative Medicine College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Alliant International University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Allied American University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Anaheim University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Angeles College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Antioch University Los Angeles"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Argosy University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Art Center College of Design"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "The Art Institute"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Ashford University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "ATI College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Antelope Valley College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Bakersfield College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Barstow Community College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Berkeley University of California"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Berkeley City College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Brandman University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Butte College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Cabrillo College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California Institute of the Arts"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California Baptist University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California Lutheran University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California Miramar University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California Polytechnic State University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California State University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California Institute of Technology"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Canada College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "College of the Canyons"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California College of the Arts"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California Community Colleges Chanellor’s Office"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "City College of San Francisco"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Cerritos College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Cerro Coso Community College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Claremont Graduate University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Chaffey College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Chapman University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California Institute of Integral Studies"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Citrus College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "The Claremont Colleges"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Claremont McKenna College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Copper Mountain College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Cogswell Polytechnical College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "College of San Mateo"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "College of the Desert"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "El Camino College Compton Center"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Contra Costa College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "College of the Sequoias"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Crafton Hills College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California State University Bakersfield"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California State University Channel Islands"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California State University Dominguez Hills"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California State University East Bay"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Fresno State"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California State University Long Beach"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California State University Monterey Bay"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California State University Northridge"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California State Polytechnic University Pomona"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California State University Sacramento"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California State University San Bernardino"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California State University San Marcos"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California State University Stanislaus"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Cuesta College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Cuyamaca College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California Western School of Law San Diego"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Cypress College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "DeAnza College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "San Joaquin Delta College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Dominican University of California"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Dominican School of Philosophy and Theology"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Diablo Valley College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "East Los Angeles College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "El Camino College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Ex’pression College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Foothill-De Anza Community College District"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Fashion Institute of Design & Merchandising"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Fielding Graduate University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Foothill College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Fresno Pacific University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Fresno City College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Frederick Taylor University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Fullerton  College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Fuller Theological Seminary"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "California State University Fullerton"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Gavilan College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Golden Gate Baptist Theological Seminary"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Glendale Community College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Gnomon School of Visual Effects"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Columbia College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Golden West College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Grossmont College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Allan Hancock College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Hartnell College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Henley-Putnam University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Harvey Mudd College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Holy Names University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Humboldt State University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Humphreys College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Imperial Valley College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "International Sports Sciences Association"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "International Technological University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Irvine Valley College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "William Jessup University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "John F. Kennedy University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Keck Graduate Institute"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Mount Saint Mary’s College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Los Angeles Community College District"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Los Angeles City College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Los Angeles Harbor College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Los Angeles Mission College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Laney  College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Los Angeles Southwest College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "La Sierra University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Las Positas College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Los Angeles Trade-Tech Community College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Laurus College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Los Angeles Valley College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of La Verne"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "UCLA School of Law"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Long Beach City College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Life Chiropractic College West"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Loma Linda University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Loyola Marymount University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Los Medanos College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Los Rios Community College District"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Lake Tahoe Community College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "College of Marin"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Marymount California University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "The Master’s College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Merced Community College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Mills College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "MiraCosta College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Modesto Junior College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Mount San Jacinto College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Mount San Antonio College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Napa Valley College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Notre Dame de Namur University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "NewSchool of Architecture and Design"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Norco College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Naval Postgraduate School"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Ohlone College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Orange Coast College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Otis College of Art and Design"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Occidental College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of the Pacific"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Pacific College of Oriental Medicine"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Palomar College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Pasadena City College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Pepperdine University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Peralta Community College District"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Pierce College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Pitzer College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Pacific Lutheran  Theological Seminary"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Point Loma Nazarene University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Pomona College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Porterville College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Pacific School of Religion"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Riverside City College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Riverside Community College District"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of Redlands"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "College of the Redwoods"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Rio Hondo College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Rosemead College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Santa Ana College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Saddleback College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of San Diego"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Santa Rosa Junior College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Santa Barbara City College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "School of Continuing Education"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Scripps College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Santa Clara University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Southern California University of Health Sciences"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "San Diego City College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "San Diego Mesa College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "San Diego State University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "San Francisco State University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Shasta College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "The Institute of Buddhist Studies"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Sierra College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Simpson University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "College of the Siskiyous"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "San Jose State University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Starr King School for the Ministry"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Skyline College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Santa Monica College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "San Mateo County Community College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Soka University of America"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Solano Community College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Sonoma State University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Stanford University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Saint Mary’s College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Taft College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Touro University California"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of California Davis"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of California Hastings College of the Law"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of California Irvine"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of California Los Angeles"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of California Los Angeles Extension"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of California Merced"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of California"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of California Press"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of California Riverside"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of California Santa Barbara"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of California Santa Cruz"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of California Santa Cruz Silicon Valley Extension"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of California San Diego"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of California San Francisco"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of California"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of the Pacific"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of Southern California"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "University of San Francisco"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "San Bernardino Valley College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Ventura College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Victor Valley College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "West Coast Baptist College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Western University of Health Sciences"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Westmont College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "West Valley College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "West Hills Community College District"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Whittier College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "West Los Angeles College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Yuba Community College District"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Yosemite Community College District"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Unitek College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Vanguard University"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Southwestern College"
  },
  {
      "Country": "United States",
      "State": "California",
      "School": "Monterey Institute of International Studies"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Adams State University"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Auraria Higher Education Center"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Aims Community College"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Arapahoe Community College"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Community College of Aurora"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Community College of Denver"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Colorado Heights University"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "University of Colorado Boulder"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Colorado College"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Colorado Mesa University"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Colorado State University"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Colorado State University-Pueblo"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "University of Denver"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Fort Lewis College"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Front Range Community College"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Jones International University"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Colorado School of Mines"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Metropolitan State University of Denver"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Naropa University"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Pikes Peak Community College"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Pueblo Community College"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Redstone College"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Regis University"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "University of the Rockies"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Red Rocks Community College"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "William Howard Taft University"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "University Corporation for Atmospheric Research"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "University of Colorado Colorado Springs"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "University of Colorado Denver"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "University of Northern Colorado"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "University of Colorado"
  },
  {
      "Country": "United States",
      "State": "Colorado",
      "School": "Western State Colorado University"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Albertus Magnus College"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Asnuntuck Community College"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Connecticut College"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Eastern Connecticut State University"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Fairfield University"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Goodwin College"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "University of Hartford"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Hartford Seminary"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "University of New Haven"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Queens University of Charlotte"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Quinebaug Valley Community College"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Sacred Heart University"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Southern Connecticut State University"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Three Rivers Community College"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Trinity College"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Tunxis Community College"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "University of Connecticut Health Center"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "University of Connecticut"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "University of Saint Joseph Connecticut"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Western Connecticut State University"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Wesleyan University"
  },
  {
      "Country": "United States",
      "State": "Connecticut",
      "School": "Yale University"
  },
  {
      "Country": "United States",
      "State": "DC",
      "School": "American University"
  },
  {
      "Country": "United States",
      "State": "DC",
      "School": "Carnegie Institution for Science"
  },
  {
      "Country": "United States",
      "State": "DC",
      "School": "The Catholic University of America"
  },
  {
      "Country": "United States",
      "State": "DC",
      "School": "Gallaudet University"
  },
  {
      "Country": "United States",
      "State": "DC",
      "School": "Georgetown University"
  },
  {
      "Country": "United States",
      "State": "DC",
      "School": "The George Washington University"
  },
  {
      "Country": "United States",
      "State": "DC",
      "School": "Howard University"
  },
  {
      "Country": "United States",
      "State": "DC",
      "School": "Johns Hopkins School of Advanced International Studies"
  },
  {
      "Country": "United States",
      "State": "DC",
      "School": "University of California Washington Center"
  },
  {
      "Country": "United States",
      "State": "DC",
      "School": "University of the District of Columbia"
  },
  {
      "Country": "United States",
      "State": "Delaware",
      "School": "Delaware State University"
  },
  {
      "Country": "United States",
      "State": "Delaware",
      "School": "Delaware Technical Community College"
  },
  {
      "Country": "United States",
      "State": "Delaware",
      "School": "Goldey-Beacom College"
  },
  {
      "Country": "United States",
      "State": "Delaware",
      "School": "University of Delaware"
  },
  {
      "Country": "United States",
      "State": "Delaware",
      "School": "Wesley College"
  },
  {
      "Country": "United States",
      "State": "Delaware",
      "School": "Wilmington University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Carlos Albizu University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Acupuncture Massage College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Atlantic Institute of Oriental Medicine"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Barry University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Broward College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "College of Central Florida"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Chipola College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Bethune-Cookman University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Dade Medical College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Daytona State College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Eckerd College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Edison State College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Embry-Riddle Aeronautical University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Everglades University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Florida Atlantic University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Florida Gulf Coast University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Florida Institute of Technology"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Florida International University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Flagler College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Florida Southern College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Florida National University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Florida State College at Jacksonville"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Florida State University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Gulf Coast State College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Hillsborough Community College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Jacksonville University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Keiser University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Loraines Academy Incorporated"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Lake Sumter State College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Lynn University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Millennia Atlantic University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Miami Dade College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "University of Miami"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Miami International University of Art and Design"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "New College of Florida"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "North Florida Community College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Nova Southeastern University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "National University of Health Sciences"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Northwest Florida State College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Palm Beach State College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Palm Beach Atlantic University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Pensacola State College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Pasco-Hernando State College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Ringling College of Art and Design"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Rollins College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Saint Leo University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "State College of Florida"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Seminole State College of Florida"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Santa Fe College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "South Florida State College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Space Coast Health Institute"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Saint Petersburg College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Stetson University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Saint Thomas University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Saint Vincent de Paul Regional Seminary"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Traviss Career Center"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "University of Central Florida"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "University of Florida"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "University of North Florida"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "University of South Florida"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "University of South Florida Sarasota-Manatee"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "University of South Florida Saint Petersburg"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "University of Tampa"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "University of West Florida"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Valencia College"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Warner University"
  },
  {
      "Country": "United States",
      "State": "Florida",
      "School": "Webber International University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Agnes Scott College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Albany Technical College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Armstrong Atlantic State University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Atlanta Technical College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Atlanta Metropolitan State College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Berry College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Carver College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Child Care Education Institute"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Central Georgia Technical College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Clayton State University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Columbus State University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Columbus Technical College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Covenant College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Dalton State"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Darton State College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "East Georgia State College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Emory University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Georgia Institute of Technology"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Georgia College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Georgia Southern University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Georgia Gwinnett College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Georgia Perimeter College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Augusta University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Georgia State University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Georgia South Western State University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Interactive College of Technology"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Atlanta’s John Marshall Law School"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Kennesaw State University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Lanier Technical College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Life University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Mercer University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Middle Georgia State College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Morehouse College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Morehouse School of Medicine"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "North Georgia Technical College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Oglethorpe University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Okefenokee Technical College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Paine College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Pfeiffer University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Piedmont College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Reinhardt University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Savannah State University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Savannah College of Art and Design"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Shorter University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Southeastern Technical College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Spelman College"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Southern Polytechnic State University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Thomas University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "University of Georgia"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "University of North Georgia"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "University System of Georgia"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Valdosta State University"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "University of West Georgia"
  },
  {
      "Country": "United States",
      "State": "Georgia",
      "School": "Wiregrass Georgia Technical College"
  },
  {
      "Country": "United States",
      "State": "Hawaii",
      "School": "Brigham Young University Hawaii"
  },
  {
      "Country": "United States",
      "State": "Hawaii",
      "School": "Chaminade University"
  },
  {
      "Country": "United States",
      "State": "Hawaii",
      "School": "University of Hawaii at Manoa"
  },
  {
      "Country": "United States",
      "State": "Hawaii",
      "School": "Mid-Pacific Institute"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "AIB College of Business"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Central College"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Coe College"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Cornell College"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Des Moines Area Community College"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Dordt College"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Drake University"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Divine Word College"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Eastern Iowa Community Colleges"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Grinnell College"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Hawkeye Community College"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Iowa State University"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Iowa Central Community College"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Iowa Wesleyan College"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Iowa Western Community College"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Kaplan University"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Kirkwood Community College"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "La’ James College"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Loras College"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Luther College"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Maharishi University of Management"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Northeast Iowa Community  College"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Palmer College of Chiropractic"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Saint Ambrose University"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Simpson College"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Southwestern Community College"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Univeristy of Iowa"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Upper Iowa University"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "University of Northern Iowa"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Wartburg College"
  },
  {
      "Country": "United States",
      "State": "Iowa",
      "School": "Waldorf College"
  },
  {
      "Country": "United States",
      "State": "Idaho",
      "School": "Boise State University"
  },
  {
      "Country": "United States",
      "State": "Idaho",
      "School": "Brigham Young University Idaho"
  },
  {
      "Country": "United States",
      "State": "Idaho",
      "School": "The College of Idaho"
  },
  {
      "Country": "United States",
      "State": "Idaho",
      "School": "College of Southern Idaho"
  },
  {
      "Country": "United States",
      "State": "Idaho",
      "School": "Idaho State University"
  },
  {
      "Country": "United States",
      "State": "Idaho",
      "School": "University of Idaho"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Augustana College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Aurora University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Benedictine University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Bradley University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "City Colleges of Chicago"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "The University of Chicago Booth School of Business"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "College of Lake County"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "College of DuPage"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Columbia College Chicago"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Danville Area Community College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "DePaul University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Dominican University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Eastern Illinois University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Elmhurst College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Governors State"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Greenville College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "The Hadley School for the Blind"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Harper College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Heartland Community College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Illinois Central College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Illinois College of Optometry"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Illinois Institute of Technology"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "University of Illinois at Urbana-Champaign"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Illinois State University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Illinois Mathematics and Science Academy"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Illinois Valley Community College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Illinois Wesleyan University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "John A. Logan College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Joliet Junior College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "The John Marshall Law School"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Judson University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Kaskaskia College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Kankakee Community College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "IIT Chicago-Kent College of Law"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Kishwaukee College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Knox College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Lake Forest College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Lakeview College of Nursing"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Lewis and Clark Community College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Lewis University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Lincoln Land Community College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Loyola University Chicago"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Midwestern Career College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "McHenry County College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "McKendree University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Midwestern University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Monmouth College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Moraine Valley Community College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Morton College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Northeastern Illinois University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Northern Illinois University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "National Louis University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "North Park University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Northwestern University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Oakton Community College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Olivet Nazarene University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Chicago ORT Technical Institute"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Parkland College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Prairie State College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Principia College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Resurrection University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Robert Morris University Illinois"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Rockford University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Rock Valley College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Roosevelt University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Rosalind Franklin University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Saint Anthony College of Nursing"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "School of the Art Institute of Chicago"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Saint Francis Medical Center College of Nursing"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Shawnee Community College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Southeastern Illinois College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Southern Illinois University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Southern Illinois University Edwardsville"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Spoon River College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "South Suburban College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "University of Saint Francis"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Southwestern Illinois College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Saint Xavier University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Trinity Christian College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "University of Chicago"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "University of Illinois at Chicago"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "University of Illinois"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "University of Illinois Springfield"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "University of Illinois at Urbana-Champaign"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Waubonsee Community College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Wheaton College"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Western Illinois University"
  },
  {
      "Country": "United States",
      "State": "Illinois ",
      "School": "Saint John’s College"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Anabaptist Mennonite Biblical Seminary"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Anderson University"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Bethel College Indiana"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Brown Mackie College"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Ball State University"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Butler University"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "DePauw University"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Earlham College"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "University of Evansville"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Goshen College"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Grace College and Seminary"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Hanover College"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Harrison College"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Holy Cross College"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Indiana University"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Indiana State University"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Indiana Wesleyan University"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Indiana University – Purdue University Fort Wayne"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Indiana University"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Indiana University Bloomington"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Indiana University East"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Indiana University Northwest"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Indiana University – Purdue University Indianapolis"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Indiana University Southeast"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Indiana University South Bend"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Ivy Tech Community College"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Manchester University"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Marian University Indianapolis"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "University of Notre Dame"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Oakland City University"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Purdue University North Central"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Purdue University"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Purdue University Calumet"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Rose-Hulman Institute of Technology"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Saint Mary’s College"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Trine University"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "University of Indianapolis"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "University of Southern Indiana"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Valparaiso University"
  },
  {
      "Country": "United States",
      "State": "Indiana",
      "School": "Wabash College"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Benedictine College"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Butler Community College"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Emporia State University"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Fort Hays State University"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Flint Hills Technical College"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Fort Scott Community College"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Garden City Community College"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Hesston College"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Highland Community College"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Johnson County Community College"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Kansas City Kansas Community College"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Kansas State University"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "The University of Kansas"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "McPherson College"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Neosho County Community College"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Newman University"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Pittsburg State University"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Saint Paul School of Theology and Ministry"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Sterling College"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "University of Saint Mary"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Washburn University"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Washburn University School of Law"
  },
  {
      "Country": "United States",
      "State": "Kansas",
      "School": "Wichita State University"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Asbury University"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Bellarmine University"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Berea College"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Centre College"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Eastern Kentucky University"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Frontier Nursing University"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Georgetown College"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Kentucky Community and Technical College System"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Kentucky Christian University"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Kentucky State University"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Lindsey Wilson College"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "The University of Louisville"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Midway College"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Morehead State University"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Murray State University"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Northern Kentucky University"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "The Southern Baptist Theological Seminary"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Saint Catharine College"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Sullivan University"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "University of the Cumberlands"
  },
  {
      "Country": "United States",
      "State": "Kentucky",
      "School": "Western Kentucky University"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Bossier Parish Community College"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Centenary College of Louisiana"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Louisiana Tech University"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Louisiana Culinary Institute"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "University of Louisiana Lafayette"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Loyola University New Orleans"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Louisiana State University"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Louisiana State University – Eunice"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "LSU Health Sciences Center – New Orleans"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "LSU Health Sciences Center – New Orleans"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Louisiana State University System"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Nicholls State University"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "New Orleans Baptist Theological Seminary"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Nunez Community College"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": " Southeastern Louisiana University"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Southern University"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Tulane University"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "University of Louisiana at Monroe"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "University of New Orleans"
  },
  {
      "Country": "United States",
      "State": "Louisiana",
      "School": "Xavier University of Louisiana"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Amherst College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Assumption College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Babson College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Boston College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Bentley University"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Berklee College of Music"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Berkshire Community College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "The Boston Conservatory"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Brandeis University"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Bridgewater State University"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Boston University"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Cambridge College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Clark University"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Curry College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Elms College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Emerson College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Emmanuel College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Endicott College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Fitchburg State University"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Framingham State University"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Gordon Conwell Theological Seminary"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Gordon College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Hampshire College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Harvard University"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Harvard Business School"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "College of the Holy Cross"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Lesley University"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Massachusetts Maritime Academy"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Massachusetts Department of Higher Education"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Massachusetts College of Art and Design"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "MassBay Community College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Marine Biological Laboratory"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Merrimack Education Center"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Merrimack College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "MGH Institute of Health Professions"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Milton Academy"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Massachusetts Institute of Technology"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Montserrat College of Art"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Mount Ida College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Mount Holyoke College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Middlesex Community College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Middlesex School"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "North Bennet Street School"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "New England Law – Boston"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Northeastern University"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Olin College of Engineering"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Salem State University"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Simmons College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Smith College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Spa Tech Institute"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Springfield College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Springfield Technical Community College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Suffolk University"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Boston Architectural College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Tufts University"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "University of Massachusetts Amherst"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "University of Massachusetts Dartmouth"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "University of Massachusetts Medical School"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "University of Massachusetts"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "University of Massachusetts Boston"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "University of Massachusetts Lowell"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Wellesley College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Wheaton College - Norton"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Wheelock College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Williams College"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Western New England University"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Worcester State University"
  },
  {
      "Country": "United States",
      "State": "Massachusetts ",
      "School": "Worcester Polytechnic Institute"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Anne Arundel Community College"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Baltimore City Community College"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Bowie State University"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Carroll Community College"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "The Community College of Baltimore County"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Chesapeake College"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Coppin State University"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "College of Southern Maryland"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Frederick Community College"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Frostburg State University"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Garrett College"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Goucher College"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Hagerstown Community  College"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Harford Community College"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Hood College"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Howard Community College"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Johns Hopkins Bloomberg School of Public Health"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Johns Hopkins University"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Loyola University Maryland"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Montgomery Blair High School"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "McDaniel College"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Maryland Institute College of Art"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Montgomery College"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Mount Saint Mary’s University"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Maryland University of Integrative Health"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Prince George’s Community College"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Salisbury University"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Sojourner-Douglass College"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Saint Mary’s College of Maryland"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Saint James School"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Towson University"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "University of  Baltimore"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "University of Maryland"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "University of  Maryland Baltimore County"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "University of Maryland"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "University of Maryland University College"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "University System of Maryland"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "United States Naval Academy"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Washington College"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Wor-Wic Community College"
  },
  {
      "Country": "United States",
      "State": "Maryland",
      "School": "Saint John’s College"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "Bates College"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "Bowdoin College"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "Central Maine Community College"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "College of the Atlantic"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "Colby College"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "Husson University"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "Maine Maritime Academy"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "Northern Maine Community College"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "Saint Joseph’s College"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "Southern Maine Community College"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "University of Maine"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "University of Maine Fort Kent"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "University of Maine at Presque Isle"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "University of New England"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "Unity College"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "York County Community College"
  },
  {
      "Country": "United States",
      "State": "Maine",
      "School": "University of Main at Augusta"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Adrian College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Albion College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Alma College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Alpena Community College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Andrews University"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Aquinas College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Baker College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Bay College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Calvin College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Central Michigan University"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "College for Creative Studies"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Cornerstone University"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Davenport University"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Delta College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Douglas J. Aveda Institute"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Eastern Michigan University"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Ferris State University"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Finlandia University"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Grand Rapids Community College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Grand Valley State University"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Henry Ford College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Hillsdale College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Hope College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Jackson College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Kettering University"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Kalamazoo Valley Community College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Kalamazoo College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Lake Michigan College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Lansing Community College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Lake Superior State University"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Lawrence Technological University"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Macomb Community College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Marygrove College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Monroe County Community College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Michigan State University"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Michigan Technological University"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Northwestern Michigan College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Northern Michigan University"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Oakland Univeristy"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Oakland Community College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Saginaw Chippewa Tribal College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Saginaw Valley State University"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "University of Detroit Mercy"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "University of Michigan-Flint"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "University of Michigan"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Wayne State"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Washtenaw Community College"
  },
  {
      "Country": "United States",
      "State": "Michigan",
      "School": "Western Michigan University"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Alexandria Technical & Community College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Anoka-Ramsey Community College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Augsburg College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Bemidji State University"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Bethel University"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Carleton College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Century College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Central Lakes College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Concordia College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Crown College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "College of Saint Benedict - Saint John’s University"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Concordia University Saint Paul"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "The College of Saint Scholastica"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Dakota County Technical College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Gustavus Adolphus College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Globe University"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Hamline University"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Inver Hills Community College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Institute of Production and Recording"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Leech Lake Tribal College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Luther Seminary"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Macalester College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "McNally Smith College of Music"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Mesabi Range College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Metropolitan State University"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Minnesota State University Moorhead"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Minnesota State University Mankato"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "North Hennepin Community College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Normandale Community College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Rasmussen College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Ridgewater College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Southwest Minnesota State University"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Saint Mary’s University of Minnesota"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "South Central College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Saint Cloud State  University"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Saint Olaf College"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "University of Saint Thomas"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "University of Minnesota"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "United Theological Seminary of the Twin Cities"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "University of Northwestern Saint Paul"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Walden University"
  },
  {
      "Country": "United States",
      "State": "Minnesota",
      "School": "Winona State Unviversity"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Assemblies of God Theological Seminary"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Aquinas Institute of Theology"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "A.T. Still University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Avila University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Columbia College"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Central Methodist University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Crowder College"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Culver-Stockton College"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Drury University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Evangel University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Fontbonne University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Hannibal-LaGrange"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Harris-Stowe State University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Jefferson College"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Kansas City University of Medicine and Biosciences"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Lincoln University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Lindenwood University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Linn State Technical College"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Maryville University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Metropolitan Community College"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Mineral Area College"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Mizzou University of Missouri"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Missouri State University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Missouri Valley College"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Missouri Southern State  University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Missouri University of Science and Technology"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "North Central Missouri College"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Nazarene Theological Seminary"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Northwest Missouri State University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Ozarks Technical Community College"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Park University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Rockhurst University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Southwest Baptist University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "South Central Career Center"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Southeast Missouri State University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Saint Louis University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Saint Charles Community College"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Saint Louis Community College"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Truman State University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "University of Central Missouri"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "University of Missouri Kansas City"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "University of Missouri Saint Louis"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "University of Missouri System"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Webster University"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Westminster College - Missouri"
  },
  {
      "Country": "United States",
      "State": "Missouri",
      "School": "Washington University in Saint Louis"
  },
  {
      "Country": "United States",
      "State": "Mississippi ",
      "School": "Alcorn State University"
  },
  {
      "Country": "United States",
      "State": "Mississippi ",
      "School": "Belhaven University"
  },
  {
      "Country": "United States",
      "State": "Mississippi ",
      "School": "Delta State University"
  },
  {
      "Country": "United States",
      "State": "Mississippi ",
      "School": "East Mississippi Community College"
  },
  {
      "Country": "United States",
      "State": "Mississippi ",
      "School": "Jackson State University"
  },
  {
      "Country": "United States",
      "State": "Mississippi ",
      "School": "Mississippi Gulf Coast Community College"
  },
  {
      "Country": "United States",
      "State": "Mississippi ",
      "School": "Mississippi State University"
  },
  {
      "Country": "United States",
      "State": "Mississippi ",
      "School": "Northeast Mississippi Community College"
  },
  {
      "Country": "United States",
      "State": "Mississippi ",
      "School": "The University of Mississippi"
  },
  {
      "Country": "United States",
      "State": "Mississippi ",
      "School": "Pearl River Community College"
  },
  {
      "Country": "United States",
      "State": "Mississippi ",
      "School": "Reformed Theological Seminary"
  },
  {
      "Country": "United States",
      "State": "Mississippi ",
      "School": "University of Mississippi Medical Center"
  },
  {
      "Country": "United States",
      "State": "Mississippi ",
      "School": "University of Southern Mississippi"
  },
  {
      "Country": "United States",
      "State": "Mississippi ",
      "School": "William Carey University"
  },
  {
      "Country": "United States",
      "State": "Mississippi ",
      "School": "Itawamba Community College"
  },
  {
      "Country": "United States",
      "State": "Montana",
      "School": "Blackfeet Community College"
  },
  {
      "Country": "United States",
      "State": "Montana",
      "School": "Carroll College"
  },
  {
      "Country": "United States",
      "State": "Montana",
      "School": "Fort Peck Community College"
  },
  {
      "Country": "United States",
      "State": "Montana",
      "School": "Flathead Valley Community College"
  },
  {
      "Country": "United States",
      "State": "Montana",
      "School": "Miles Community College"
  },
  {
      "Country": "United States",
      "State": "Montana",
      "School": "Montana State University"
  },
  {
      "Country": "United States",
      "State": "Montana",
      "School": "Montana State University Billings"
  },
  {
      "Country": "United States",
      "State": "Montana",
      "School": "Montana State University – Northern"
  },
  {
      "Country": "United States",
      "State": "Montana",
      "School": "Montana Tech of the University of Montana"
  },
  {
      "Country": "United States",
      "State": "Montana",
      "School": "Montana University System"
  },
  {
      "Country": "United States",
      "State": "Montana",
      "School": "Rocky Mountain College"
  },
  {
      "Country": "United States",
      "State": "Montana",
      "School": "University of Montana Helena College"
  },
  {
      "Country": "United States",
      "State": "Montana",
      "School": "University of Montana"
  },
  {
      "Country": "United States",
      "State": "Montana",
      "School": "University of Montana Western"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Asheville-Buncombe Technical Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Alamance Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Appalachian State University"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Bladen Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Body Therapy Institute"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Campbell University"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Cape Fear Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Charlotte School of Law"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Chowan University"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Central Piedmont Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Craven Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Davidson College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Duke University"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Durham Technical Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Elizabeth City State University"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "East Carolina University"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Elon University"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Fayetteville Technical Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Forsyth Technical Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Gardner-Webb University"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Gaston College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Guilford Technical Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Heritage Bible College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "High Point University"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Isothermal Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Lenoir Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Lees McRae College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Methodist University"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "The University of Mount Olive"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Montgomery Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "North Carolina Central University"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "North Carolina School of Science and Mathematics"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "North Carolina State University"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "North Carolina Wesleyan College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "New Life Theological Seminary"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "University of North Carolina"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Piedmont Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Pitt Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Queens University of Charlotte"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Randolph Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Roanoke-Chowan Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Salem College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Sampson Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Sandhills Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Saint Andrews University"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Southeastern Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Southeastern Baptist Theological Seminary"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Shaw University"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Southwestern Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "South Piedmont Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Stanly Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Saint Augustine’s University"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "University of North Carolina at Chapel Hill"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "University of North Carolina Asheville"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "University of North Carolina Charlotte"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "University of North Carolina Greensboro"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "University of North Carolina Pembroke"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "University of North Carolina School of the Arts"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "University of North Carolina Wilmington"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Vance-Granville Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Wake Technical Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Warren Wilson College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Western Carolina University"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Wake Forest University"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Western Piedmont Community College"
  },
  {
      "Country": "United States",
      "State": "North Carolina ",
      "School": "Winston-Salem State University"
  },
  {
      "Country": "United States",
      "State": "North Dakota",
      "School": "Dakota College at Bottineau"
  },
  {
      "Country": "United States",
      "State": "North Dakota",
      "School": "Mayville State University"
  },
  {
      "Country": "United States",
      "State": "North Dakota",
      "School": "Minot State University"
  },
  {
      "Country": "United States",
      "State": "North Dakota",
      "School": "North Dakota State University"
  },
  {
      "Country": "United States",
      "State": "North Dakota",
      "School": "North Dakota University System"
  },
  {
      "Country": "United States",
      "State": "North Dakota",
      "School": "Turtle Mountain Community College"
  },
  {
      "Country": "United States",
      "State": "North Dakota",
      "School": "University of North Dakota"
  },
  {
      "Country": "United States",
      "State": "North Dakota",
      "School": "United Tribes Technical College"
  },
  {
      "Country": "United States",
      "State": "North Dakota",
      "School": "Valley City State University"
  },
  {
      "Country": "United States",
      "State": "North Dakota",
      "School": "Williston State College"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "Bellevue University"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "Bryan College of Health Sciences"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "Creighton University"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "Chadron State College"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "Concordia University Nebraska"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "Joseph’s College"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "Little Priest Tribal College"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "Mid-Plains Community College"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "University of Nebraska"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "Northeast Community College"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "Union College"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "University of Nebraska at Kearney"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "University of Nebraska at Lincoln"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "University of Nebraska Medical Center"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "University of Nebraska Omaha"
  },
  {
      "Country": "United States",
      "State": "Nebraska",
      "School": "Wayne State College"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "Saint Anselm College"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "Antioch University New England"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "Community College System of New Hampshire"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "Colby Sawyer College"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "Dartmouth College"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "Phillips Exeter Academy"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "Granite State College"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "Keene State College"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "Manchester Community College"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "Mount Washington College"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "Nashua Community College"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "New England College"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "NHTI Concord’s Community College"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "Plymouth State University"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "Rivier University"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "Southern New Hampshire University"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "University of New Hampshire"
  },
  {
      "Country": "United States",
      "State": "New Hampshire",
      "School": "White Mountains Community College"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Atlantic Cape Community College"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Burlington County College"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Bergen Community College"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Brookdale Community College"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Centenary College of New Jersey"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Drew University"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Eastwick College"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Fairleigh Dickinson University"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Felician College"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Fortis Institute"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Georgian Court University"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Kean University"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Mercer County Community  College"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Middlesex County College"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Monmouth University"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Montclair State University"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "New Jersey City University"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "New Jersey Institute of Technology"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Ocean County College"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Princeton University"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Princeton Theological Seminary"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Ramapo College of New Jersey"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Raritan Valley Community College"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Rider University"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Rowan University"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Rutgers University"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Seton Hall University"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Stenotech Career Institute"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Stevens Institute of Technology"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Stockton College"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Sussex County Community College"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "The College of New Jersey"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Thomas Edison State College"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "William Paterson University"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "County College of Morris"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Camden County College"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Passaic County Community College"
  },
  {
      "Country": "United States",
      "State": "New Jersey",
      "School": "Ross University"
  },
  {
      "Country": "United States",
      "State": "New Mexico",
      "School": "Central New Mexico"
  },
  {
      "Country": "United States",
      "State": "New Mexico",
      "School": "Eastern New Mexico University"
  },
  {
      "Country": "United States",
      "State": "New Mexico",
      "School": "New Mexico Highlands University"
  },
  {
      "Country": "United States",
      "State": "New Mexico",
      "School": "New Mexico State University"
  },
  {
      "Country": "United States",
      "State": "New Mexico",
      "School": "New Mexico State University Alamogordo"
  },
  {
      "Country": "United States",
      "State": "New Mexico",
      "School": "New Mexico Institute of Mining and Technology"
  },
  {
      "Country": "United States",
      "State": "New Mexico",
      "School": "Northern New Mexico College"
  },
  {
      "Country": "United States",
      "State": "New Mexico",
      "School": "San Juan College"
  },
  {
      "Country": "United States",
      "State": "New Mexico",
      "School": "Southwestern College"
  },
  {
      "Country": "United States",
      "State": "New Mexico",
      "School": "Univeristy of New Mexico"
  },
  {
      "Country": "United States",
      "State": "New Mexico",
      "School": "University of the Southwest"
  },
  {
      "Country": "United States",
      "State": "Nevada",
      "School": "College of Southern Nevada"
  },
  {
      "Country": "United States",
      "State": "Nevada",
      "School": "Great Basin College"
  },
  {
      "Country": "United States",
      "State": "Nevada",
      "School": "Pima Medical Institute"
  },
  {
      "Country": "United States",
      "State": "Nevada",
      "School": "Sierra Nevada College"
  },
  {
      "Country": "United States",
      "State": "Nevada",
      "School": "Truckee Meadows Community College"
  },
  {
      "Country": "United States",
      "State": "Nevada",
      "School": "University of Nevada Las Vegas"
  },
  {
      "Country": "United States",
      "State": "Nevada",
      "School": "University of Nevada Reno"
  },
  {
      "Country": "United States",
      "State": "Nevada",
      "School": "Western Nevada College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Adelphi University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "University at Albany"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Alfred University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "The American Musical and Dramatic Academy"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "ASA College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Bard College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Barnard College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Binghamton University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "The College at Brockport"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "University at Buffalo"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Buffalo State University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Cazenovia College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Clarkson University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Clinton Community College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "The College of New Rochelle"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Cobleskill University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Colgate University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Columbia University in the City of New York"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Concordia College New York"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "The Cooper Union"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Cornell University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Cortland College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "The City University of New York"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "The College of Westchester"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Daemen College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Dominican College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Delhi State University of New York"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Dowling College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "D’Youville College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Erie Community College State University of New York"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Elim Bible Institute"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Elmira College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Empire State College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "College of Environmental Science and Forestry"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Farmingdale State College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Fashion Institute of Technology"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Finger Lakes Community College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Fordham University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Fredonia University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Five Towns College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Geneseo University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Globe Institute of Technology"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "The General Theological Seminary"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Hamilton College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Hartwick College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Herkimer College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Hofstra University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Hudson Valley Community College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Hobart and William Smith Colleges"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Institute of Design and Construction"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Iona College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Ithaca College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "The Jewish Theological Seminary"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "The Juilliard School"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Keuka College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Lehman College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Le Moyne"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Lim College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Long Island University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Manhattan College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Marist College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Metropolitan College of New York"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Mercy College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Marymount Manhattan College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Monroe Community College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Morrisville State College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Mount Saint Marry College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Icahn School of Medicine at Mount Sinai"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Manhattanville College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Nazareth College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Nassau Community College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "New Paltz"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "The New School"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Niagara University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Nyack College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "New York College of Health Professions"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "New York Film Academy"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "New York Institute of Technology"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "New York University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "State University of New York at Oneonta"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "State University of New York at Oswego"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Pace University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Paul Smith’s College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "State University of New York at Plattsburgh"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "State University of New York at Potsdam"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Pratt Institute"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Purchase College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Rochester Institute of Technology"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Roberts Wesleyan College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "University of Rochester"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Rensselaer Polytechnic Institute"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "The Sages Colleges"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Saint Bonaventure University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "The New York Conservatory for Dramatic Arts"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Siena College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Saint John Fisher College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Skidmore College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Sarah Lawrence College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Saint Bernard’s School of Theology and Ministry"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Saint John’s University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Saint Lawrence University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Stony Brook University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Stony Brook Medicine"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "The College of Saint Rose"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "State University of New York"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "State University of New York at Adirondack"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "State University of New Institute of Technology"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Jamestown Community College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Orange County Community College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Rockland Community College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Suffolk County Community College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Westchester Community College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Syracuse University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Tompkins Cortland Community College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "The Touro College and University System"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Touro College Jacob D. Fuchsberg Law Center"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Union College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Upstate  Medical University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "United States Military Academy West Point"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Utica College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Vassar College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Wagner College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Wells College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Yeshiva University"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Canton State University of New York"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Excelsior College"
  },
  {
      "Country": "United States",
      "State": "New York",
      "School": "Culinary Institute of America"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Ashland University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Aultman College of Nursing and Health Sciences"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Belmont College"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Bowling Green State University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Baldwin Wallace University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Capital University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Case Western Reserve University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Cincinnati College of Mortuary Science"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Cedarville University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Central State University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Cincinnati State Technical and Community College"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Central Ohio Technical College"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Columbus State Community College"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Cleveland State University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Western Reserve University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Defiance College"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Denison University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "The University of Findlay"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Franklin University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Heidelberg University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Hiram College"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Hocking College"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "John Carroll University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Kettering College"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Kent State University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Kenyon College"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Lakeland Community College"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Lima Central Catholic High School"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Lorain County Community College"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Malone University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Marietta College"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Miami University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "University of Mount Union"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Mount Saint Joseph University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Muskingum University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Mount Vernon Nazarene University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "North Central State College"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Oberlin College and Conservatory"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Ohio University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Ohio Dominican University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Ohio State University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Ohio Northern University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Otterbein University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Owens Community College"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Ohio Wesleyan University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "University of Rio  Grande"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Shawnee State University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Sinclair Community College"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Tiffin University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Cuyahoga Community College"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "The University of Akron"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "University of Cincinnati"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "University of Cincinnati Blue Ash"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "University of Cincinnati Clermont"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "University of Dayton"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Urbana University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Ursuline College"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "University of Toledo"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Walsh University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Wilmington College"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Wittenberg University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "The College of Wooster"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Wright State University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Xavier University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Youngstown State University"
  },
  {
      "Country": "United States",
      "State": "Ohio",
      "School": "Ohio State University"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Cameron University"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Connors State College"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "East  Central University"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Langston University"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Mid-America Christian University"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Meridian Technology Center"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Northeastern State University"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Northwestern Oklahoma State University"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Oklahoma Christian University"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Oklahoma City Community College"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Oklahoma City University"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Oklahoma State University"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Oral Roberts University"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Oklahoma State University Institue of Technology"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Oklahoma State University"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "The University of Oklahoma"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "The University of Oklahoma Health Sciences Center"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Rose State College"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Rogers State University"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Southeastern Oklahoma State University"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Southwestern Christian University"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Southwestern Oklahoma State Univeristy"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Tulsa Community College"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "University of Central Oklahoma"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "University of Science and Arts of Oklahoma"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "University of Tulsa"
  },
  {
      "Country": "United States",
      "State": "Oklahoma",
      "School": "Western Oklahoma State College"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Blue Mountain Community College"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Clatsop Community College"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Central Oregon Community College"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Columbia School of English"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Concordia University Portland Oregon"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Eastern Oregon University"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "George Fox University"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Lane Community College"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Lewis and Clark"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Linfield College"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Linn-Benton Community College"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Marylhurst University"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "National College of Natural Medicine"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Oregon Health and Science University"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Oregon State University"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Pacific University Oregon"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Portland Community College"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Portland State University"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Reed College"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Rogue Community College"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Southwestern Oregon Community  College"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Southern Oregon University"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "University of Oregon"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "University of Portland"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Warner Pacific College"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Willamette University"
  },
  {
      "Country": "United States",
      "State": "Oregon",
      "School": "Western Oregon University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Allegheny College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Alvernia University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Arcadia University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Baptist Bible College & Seminary"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Butler County Community College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Bloomsburg University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Bryn Mawr College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Bucknell University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Bucks County Community College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "California University of Pennsylvania"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Carlow University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Community College of Allegheny County"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Community College of Philadelphia"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Cedar Crest College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Chatham University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Chestnut Hill College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Clarion University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Carnegie Mellon University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Delaware County Community College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Delaware Valley College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Dickinson College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Drexel University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Drexel University College of Medicine"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Duquesne University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Eastern University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Edinboro University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Elizabethtown College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Evangelical Seminary"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Franklin & Marshall College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Saint Francis University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Grove City College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Geneva College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Gettysburg College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Harrisburg Area Community College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Haverford College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Holy Family University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Indiana University of Pennsylvania"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Thomas Jefferson University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Juniata College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Keystone College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "King’s College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Kutztown University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Lackawanna College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Lafayette College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Lancaster County Career and Technology Center"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Lancaster Theological Seminary"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "La Roche College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "La Salle University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Lehigh Carbon Community College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Lake Erie College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Lehigh University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Lock Haven University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "The Lincoln University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Lansdale School of Business"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Lebanon Valley College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Lycoming College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Manor College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Mansfield University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Marywood University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Montgomery County Community College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Mercyhurst University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Messiah College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Millersville University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Misericordia University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Moravian College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Mount Aloysius College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Muhlenberg College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Neumann University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Northampton Community College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Pennsylvania Gunsmith School"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Philadelphia College of Osteopathic Medicine"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Pennsylvania College of Technology"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Philadelphia University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "University of Pittsburgh"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Penn State University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Reading Area Community College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Robert Morris University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Saint Vincent Seminary"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Salus University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "The University of Scranton"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Shippensburg University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Saint Joseph’s University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Slippery Rock University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Saint Vincent College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Susquehanna University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Swarthmore College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Temple University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "The  American College of Financial Services"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Thiel College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "University of the Arts"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "University of Pennsylvania"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "University of the Sciences in Philadelphia"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Valley Forge Christian College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Villanova University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Washington and Jefferson  College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Westmoreland County Community College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "West  Chester University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Westminster College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Widener University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Wilkes University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Wilson College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "York College of Pennsylvania"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Pennsylvania Academy of the Fine Arts"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "East Stroudsburg University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Ursinus College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "DeSales University"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Lancaster Bible College"
  },
  {
      "Country": "United States",
      "State": "Pennsylvania ",
      "School": "Cheyney University of Pennsylvania"
  },
  {
      "Country": "United States",
      "State": "Rhode Island",
      "School": "Brown University"
  },
  {
      "Country": "United States",
      "State": "Rhode Island",
      "School": "Bryant University"
  },
  {
      "Country": "United States",
      "State": "Rhode Island",
      "School": "Community College of Rhode Island"
  },
  {
      "Country": "United States",
      "State": "Rhode Island",
      "School": "Johnson and Wales University"
  },
  {
      "Country": "United States",
      "State": "Rhode Island",
      "School": "New England Institute of Technology"
  },
  {
      "Country": "United States",
      "State": "Rhode Island",
      "School": "Providence College"
  },
  {
      "Country": "United States",
      "State": "Rhode Island",
      "School": "The University of Rhode Island"
  },
  {
      "Country": "United States",
      "State": "Rhode Island",
      "School": "Rhode Island College"
  },
  {
      "Country": "United States",
      "State": "Rhode Island",
      "School": "Rhose Island School of Design"
  },
  {
      "Country": "United States",
      "State": "Rhode Island",
      "School": "Roger Williams University"
  },
  {
      "Country": "United States",
      "State": "Rhode Island",
      "School": "University of Rhode Island"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Centura College"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "The Citadel Military College of South Carolina"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Columbia International University"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Clemson University"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Coastal Carolina University"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "College of Charleston"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Coker College"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Columbia College South Carolina"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Florence-Darlington Technical College"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Francis Marion University"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Forrest College"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Furman University"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Lander University"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Limestone College"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Midlands Technical College"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Medical University of South Carolina"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Newberry College"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "North Greenville University"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Orangeburg-Calhoun Technical College"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Presbyterian College"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "University of South Carolina"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "South Carolina State University"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Sinte Gleska University"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Spartanburg Methodist College"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "TriCounty Technical College"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "University of South Carolina Aiken"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "University of South Carolina Beaufort"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "University of South Carolina Upstate"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Winthrop University"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Wofford College"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "York Technical College"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Bob Jones University"
  },
  {
      "Country": "United States",
      "State": "South Carolina",
      "School": "Anderson University"
  },
  {
      "Country": "United States",
      "State": "South Dakota",
      "School": "Black Hills State University"
  },
  {
      "Country": "United States",
      "State": "South Dakota",
      "School": "Dakota State University"
  },
  {
      "Country": "United States",
      "State": "South Dakota",
      "School": "Dakota Wesleyan University"
  },
  {
      "Country": "United States",
      "State": "South Dakota",
      "School": "Mount Marty College"
  },
  {
      "Country": "United States",
      "State": "South Dakota",
      "School": "Northern State University"
  },
  {
      "Country": "United States",
      "State": "South Dakota",
      "School": "South Dakota School of Mines and Technology"
  },
  {
      "Country": "United States",
      "State": "South Dakota",
      "School": "South Dakota State University"
  },
  {
      "Country": "United States",
      "State": "South Dakota",
      "School": "University of South Dakota"
  },
  {
      "Country": "United States",
      "State": "South Dakota",
      "School": "University of Sioux Falls"
  },
  {
      "Country": "United States",
      "State": "South Dakota",
      "School": "Western Dakota Technical Institute"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Austin Peay State University"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Belmont University"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Bryan College"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Christian Brothers University"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Carson-Newman University"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Columbia State Community College"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Cumberland University"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "DeVry University"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "East Tennessee State University"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Freed-Hardeman University"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Fisk University"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Huntington College of Health Sciences"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Hiwassee College"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Johnson University"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Jackson State Community College"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Lee University"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Lincoln Memorial University"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "The LeMoyne-Owen College"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "The University of Memphis"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Milligan College"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Middle Tennessee State University"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Nashville State Community College"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Pellissippi State Community College"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Rhodes College"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Roane State Community College"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Southern College of Optometry"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Sewanee The University of the South"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Southern Adventist University"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "The University of Tennessee"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Southwest Tennessee Community College"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Tennessee State University"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Tennessee Technological University"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Tennessee Wesleyan College"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "University of Tennessee Chattanooga"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "University of Tennessee Health Science Center"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "University of Tennessee Knoxville"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "University of Tennessee Martin"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "University of Tennessee Space Institute"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Union University"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Vanderbilt University"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "Volunteer State Community College"
  },
  {
      "Country": "United States",
      "State": "Tennessee ",
      "School": "King University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Abilene Christian University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Alamo Colleges"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Alvin Community College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Angelo State University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Austin Community College District"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Austin College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Austin Graduate School of Theology"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Baylor University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Blinn College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Brazosport College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Brookhaven College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Baptist Health System School of Health Professions"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Career Point College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Cedar Valley College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Coastal Bend College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "College of the Mainland"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Concordia University Texas"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Central Texas College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Culinary Institute LeNotre"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Dallas Baptist University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Del Mar College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Dallas Nursing Institute"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "El Paso Community College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "East Texas Baptist University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Galen College of Nursing"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Galveston College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Grayson College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Houston Baptist University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Houston Community College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Hill College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Howard College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Howard Payne University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Lamar University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Lamar State College – Port Arthur"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Lubbock Christian University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "LeTourneau University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Lamar Institute of Technology"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Lone Star College System"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Lamar State College – Orange"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "McLennan Community College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "McMurry University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Midland College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Midwestern  State University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "National American University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "North Central Texas College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "North American University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "North Lake College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Odessa College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Ogle School"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Our Lady of the Lake University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Panola College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Patty Hands Shelton School of Nursing"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Prairie View A&M University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Rice University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Richland College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "San Jacinto College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Schreiner University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Stephen F. Austin State University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Sam Houston State University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Southern Methodist University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "South Plains College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "South Texas College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Southwestern University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Seminary of the Southwest"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "South Texas College of Law"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Saint Edward’s University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Saint Mary’s University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Saint Thomas"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas A&M Health Science Center"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas A&M International University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas A&M University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas A&M University Commerce"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas A&M University Corpus Christi"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas A&M University Kingsville"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas A&M University Texarkana"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Tarleton State University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas Christian University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Temple College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Tyler Junior College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Trinity University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas State Technical College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas Southern University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas Tech University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas Tech University Health Sciences Center"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas Woman’s University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas Chiropractic College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Texas State University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Dallas"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Universty of Houston"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Houston Clear Lake"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Houston Downtown"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of the Incarnate Word"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Mary Hardin-Baylor"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of North Texas"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of North Texas Health Science Center"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas Arlington"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas Brownsville"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas Dallas"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas at El Paso"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas at Austin"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas Health Science Center Houston"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas Health Science Center San Antonio"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas Medical Branch at Galveston"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas Pan American"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas of the Permian Basin"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas at San Antonio"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas Southwestern Medical Center"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "University of Texas at Tyler"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Valley Grande Institute"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Victoria College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Wayland Baptist University"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "Weatherford College"
  },
  {
      "Country": "United States",
      "State": "Texas",
      "School": "West Texas A&M University"
  },
  {
      "Country": "United States",
      "State": "USVI",
      "School": "University of the Virgin Islands"
  },
  {
      "Country": "United States",
      "State": "Utah",
      "School": "Brigham Young University"
  },
  {
      "Country": "United States",
      "State": "Utah",
      "School": "Dixie State University"
  },
  {
      "Country": "United States",
      "State": "Utah",
      "School": "Salt Lake Community College"
  },
  {
      "Country": "United States",
      "State": "Utah",
      "School": "Snow College"
  },
  {
      "Country": "United States",
      "State": "Utah",
      "School": "Southern Utah University"
  },
  {
      "Country": "United States",
      "State": "Utah",
      "School": "Utah State University"
  },
  {
      "Country": "United States",
      "State": "Utah",
      "School": "University of Utah"
  },
  {
      "Country": "United States",
      "State": "Utah",
      "School": "Utah Valley University"
  },
  {
      "Country": "United States",
      "State": "Utah",
      "School": "Weber State University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Averett University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Christendom College"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Christopher Newport University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Dabney S. Lancaster Community College"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Eastern Mennonite University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Eastern Virginia Medical School"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Ferrum College"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Germanna Community College"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "George Mason University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Hampden-Sydney College"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "The Institute for the Psychological Sciences"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "James Madison University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Liberty University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Longwood University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Marymount University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "New River Community College"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Norfolk State University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Northern Virginia Community College"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Old Dominion University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Radford University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Randolph College"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Rappahannock Community College"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Regent University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Reynolds Community College"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "University of Richmond"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Randolph-Macon College"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Roanoke College"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Sentara College of Health Sciences"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Stratford University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Shenandoah University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Southern Virgina University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Southwest Virgina Community College"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Tidewater Community College"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Thomas Nelson Community College"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "University of Mary Washington"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "University of Virginia’s College at Wise"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Virginia’s Community Colleges"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Virginia Commonwealth University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Virgina Highlands Community College"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Virginia Institute of Marine Science"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "University of Virginia"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Virginia Western Community College"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Virginia International University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Virginia State University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Virginia Polytechnic Institute and State University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Virginia Union University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Virginia Wesleyan College"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "Washington and Lee University"
  },
  {
      "Country": "United States",
      "State": "Virginia ",
      "School": "The College of William and Mary"
  },
  {
      "Country": "United States",
      "State": "Vermont",
      "School": "Castleton State College of Vermont"
  },
  {
      "Country": "United States",
      "State": "Vermont",
      "School": "Champlain College"
  },
  {
      "Country": "United States",
      "State": "Vermont",
      "School": "Green Mountain College"
  },
  {
      "Country": "United States",
      "State": "Vermont",
      "School": "Johnson State College"
  },
  {
      "Country": "United States",
      "State": "Vermont",
      "School": "Middlebury College"
  },
  {
      "Country": "United States",
      "State": "Vermont",
      "School": "New England Culinary Institute"
  },
  {
      "Country": "United States",
      "State": "Vermont",
      "School": "Norwich  University"
  },
  {
      "Country": "United States",
      "State": "Vermont",
      "School": "School for International Training"
  },
  {
      "Country": "United States",
      "State": "Vermont",
      "School": "Saint Michael’s College"
  },
  {
      "Country": "United States",
      "State": "Vermont",
      "School": "University of Vermont"
  },
  {
      "Country": "United States",
      "State": "Vermont",
      "School": "University of Vermont"
  },
  {
      "Country": "United States",
      "State": "Vermont",
      "School": "Vermont Law School"
  },
  {
      "Country": "United States",
      "State": "Vermont",
      "School": "Vermont Technical College"
  },
  {
      "Country": "United States",
      "State": "Vermont",
      "School": "Bennington College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Bellevue College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Big Bend Community College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Cascadia Community College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Centralia College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Charter College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Clark College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Central Washington University"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "DigiPen Institute of Technology"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Edmonds Community College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Everett Community College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "The Evergreen State College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Eastern Washington University"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Faith Evangelical College and Seminary"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Gonzaga University"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Green River Community College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Highline College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Mukogawa Fort Wright Institute"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "North Seattle College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Olympic College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Peninsula College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Perry Technical Institute"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Pacific Lutheran University"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Renton Technical College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Seattle Central College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Seattle University"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Shoreline Community College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Seattle Institute of Oriental Medicine"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Skagit Valley College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "South Seattle College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Spokane Falls Community College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Seattle Pacific University"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Saint Martin’s University"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "University of Puget Sound"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "University of Washington"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "University of Washington Bothell"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Walla Walla University"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Whitman College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Whitworth University"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Washington State University"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Wenatchee Valley College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Walla Walla Community College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Western Washington University"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "Yakima Valley Community College"
  },
  {
      "Country": "United States",
      "State": "Washington",
      "School": "University of Washington"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Alverno College"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Carroll University"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Carthage College"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Chippewa Valley Technical College"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Edgewood College"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Gateway Technical College"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "The Institute of Beauty and Wellness"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Lawrence University"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Madison Area Technical College"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Marquette University"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Milwaukee Area Technical College"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Medical College of Wisconsin"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Milwaukee Institute of Art and Design"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Moraine Park Technical College"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Milwaukee School of Engineering"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Northland College"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Northcentral  Technical College"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Northeast Wisconsin Technical College"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Silver Lake College of the Holy Family"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Saint Norbert College"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Cardinal Stritch University"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "University of Wisconsin Colleges"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "University of Wisconsin Eau Claire"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "University of Wisconsin Extension"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "University of Wisconsin Green Bay"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "University of Wisconsin La Crosse"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "University of Wisconsin Milwaukee"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "University of Wisconsin Oshkosh"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "University of Wisconsin Platteville"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "University of Wisconsin River Falls"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "University of Wisconsin Stevens Point"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "University of Wisconsin Superior"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "University of Wisconsin Whitewater"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Viterbo University"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Waukesha County Technical College"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "University of Wisconsin - Madison"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Wisconsin Indianhead Technical College"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Wisconsin Lutheran College"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Wisconsin Technical College System"
  },
  {
      "Country": "United States",
      "State": "Wisconsin",
      "School": "Western Technical College"
  },
  {
      "Country": "United States",
      "State": "West Virginia ",
      "School": "American Public University System"
  },
  {
      "Country": "United States",
      "State": "West Virginia ",
      "School": "Concord University"
  },
  {
      "Country": "United States",
      "State": "West Virginia ",
      "School": "Eastern West Virgina Community and Technical College"
  },
  {
      "Country": "United States",
      "State": "West Virginia ",
      "School": "Fairmont State University"
  },
  {
      "Country": "United States",
      "State": "West Virginia ",
      "School": "Marshall University"
  },
  {
      "Country": "United States",
      "State": "West Virginia ",
      "School": "Ohio Valley University"
  },
  {
      "Country": "United States",
      "State": "West Virginia ",
      "School": "Pierpont Community and Technical College"
  },
  {
      "Country": "United States",
      "State": "West Virginia ",
      "School": "Shepherd University"
  },
  {
      "Country": "United States",
      "State": "West Virginia ",
      "School": "University of Charleston"
  },
  {
      "Country": "United States",
      "State": "West Virginia ",
      "School": "West Liberty University"
  },
  {
      "Country": "United States",
      "State": "West Virginia ",
      "School": "Wheeling Jesuit University"
  },
  {
      "Country": "United States",
      "State": "West Virginia ",
      "School": "West Virginia Northern Community College"
  },
  {
      "Country": "United States",
      "State": "West Virginia ",
      "School": "West Virginia State University"
  },
  {
      "Country": "United States",
      "State": "West Virginia ",
      "School": "West Virginia University"
  },
  {
      "Country": "United States",
      "State": "West Virginia ",
      "School": "West Virginia Wesleyan College"
  },
  {
      "Country": "United States",
      "State": "Wyoming",
      "School": "Casper College"
  },
  {
      "Country": "United States",
      "State": "Wyoming",
      "School": "Central Wyoming College"
  },
  {
      "Country": "United States",
      "State": "Wyoming",
      "School": "National Outdoor Leadership School"
  },
  {
      "Country": "United States",
      "State": "Wyoming",
      "School": "Northwest College"
  },
  {
      "Country": "United States",
      "State": "Wyoming",
      "School": "Northern Wyoming Community College District"
  },
  {
      "Country": "United States",
      "State": "Wyoming",
      "School": "University of Wyoming"
  }
]